import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { DashboardService } from "../../../providers/dashboard.service";
import { AuthService } from "../../../providers/auth.service";
import { Modules } from "src/app/core/model/modules.enum";
import { MessageService } from "primeng/api";
import { environment } from "../../../../environments/environment";

import { NgxUiLoaderService } from "ngx-ui-loader";

import { ApexAxisChartSeries, ApexNonAxisChartSeries, ApexGrid, ApexChart, ApexXAxis, ApexYAxis, ApexMarkers, ApexStroke, ApexLegend, ApexResponsive, ApexTooltip, ApexFill, ApexDataLabels, ApexPlotOptions, ApexTitleSubtitle } from 'ng-apexcharts';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CustomersTpnListv2Component } from './customers-tpn-listv2/customers-tpn-listv2.component';
import { DeactivatedMerchantListv2Component } from './deactivated-merchant-listv2/deactivated-merchant-listv2.component';
import { NotTransactTpnlistv2Component } from './not-transact-tpnlistv2/not-transact-tpnlistv2.component';
import { LessSalesMerchantsv2Component } from './less-sales-merchantsv2/less-sales-merchantsv2.component';
import { CommonService } from 'src/app/providers/common.service';
import {apiLinks} from "../../../core/api-links/api-links";

import * as moment from 'moment';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { get, isEmpty, isSet, orderBy, round, sortBy, toArray, toInteger, uniq, map as lodashMap, filter, truncate, concat } from 'lodash';
import { NgSelectComponent } from '@ng-select/ng-select';

var zipcode_to_timezone = require( 'zipcode-to-timezone' );
var zipcodes = require('zipcodes');

export type apexChartOptions = {
  series: ApexAxisChartSeries;
  nonAxisSeries: ApexNonAxisChartSeries;
  colors: string[];
  grid: ApexGrid;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  markers: ApexMarkers,
  stroke: ApexStroke,
  legend: ApexLegend,
  responsive: ApexResponsive[],
  tooltip: ApexTooltip,
  fill: ApexFill
  dataLabels: ApexDataLabels,
  plotOptions: ApexPlotOptions,
  labels: string[],
  title: ApexTitleSubtitle
};

@Component({
  selector: 'systemv2-dashboard',
  templateUrl: './dashboardv2-system.component.html',
  styleUrls: ['./dashboardv2.component.scss'],
  preserveWhitespaces: true
})
export class Dashboardv2SystemComponent implements OnInit {
  public userPrivilege: any;
  modalRef: NgbModalRef;
  /**
   * Apex chart
   */
  public apexChart1Options: Partial<apexChartOptions>;
  public apexChart2Options: Partial<apexChartOptions>;
  public apexChart3Options: Partial<apexChartOptions>;
  public apexChart4Options: Partial<apexChartOptions>;
  public apexChart5Options: Partial<apexChartOptions>;
  public apexChart6Options: Partial<apexChartOptions>;
  public apexChart7Options: Partial<apexChartOptions>;
  public apexChart8Options: Partial<apexChartOptions>;
  public apexChart9Options: Partial<apexChartOptions>;
  public apexChartOptions: Partial<apexChartOptions>;
  public apexChartTVDefault30: Partial<apexChartOptions>;
  public apexChartTCDefault30: Partial<apexChartOptions>;
  public apexChartDefaultMerchant30: Partial<apexChartOptions>;
  public apexChartCBDefault30: Partial<apexChartOptions>;

  public apexChart10Options: Partial<apexChartOptions>;
  public apexChart11Options: Partial<apexChartOptions>;
  public apexChart12Options: Partial<apexChartOptions>;
  public apexChart13Options: Partial<apexChartOptions>;
  public apexChart20Options: Partial<apexChartOptions>;
  public apexChart21Options: Partial<apexChartOptions>;
  public apexChart22Options: Partial<apexChartOptions>;
  public apexChart23Options: Partial<apexChartOptions>;
  public apexChart24Options: Partial<apexChartOptions>;  
  public apexChartMCCOptions: Partial<apexChartOptions>;  
  public apexChartLongevityOptions: Partial<apexChartOptions>;
  public apexChartMDTodayOptions: Partial<apexChartOptions>;
  public apexChartSPCustomer: Partial<apexChartOptions>;
  public apexChartSPCustomer2:Partial<apexChartOptions>;
  public apexChartSPCustomer3:Partial<apexChartOptions>;
  public chart2ShowOption: Partial<apexChartOptions> = {};
  public chart2MerchantLastMonth: Partial<apexChartOptions> = {};
  public chart2MerchantThisMonth: Partial<apexChartOptions>  = {};
  public chart2MerchantToday: Partial<apexChartOptions> = {};

  public modalWidget1: string = "";
  public modalWidget2: string = "";
  public modalWidget3: string = "";
  public modalWidget4: string = "";
  public modalWidget5: string = "";
  public modalWidget6: string = "";
  public modalWidget7: string = "";
  public modalWidget8: string = "";
  public modalWidget9: string = "";

  public modalWidget10: string = "";
  public modalWidget11: string = "";
  public modalWidget12: string = "";
  public modalWidget13: string = "";
  public modalWidgetActivity01: string = "";
  public modalWidgetNTTPN: string = "";
  public modalWidgetLSM: string = "";
  public modalWidgetDS: string = "";
  public modalWidgetLongevity: string = "";
  public modalWidgetMDToday: string = "";
  public modalWidgetSPCustomer: string = "";
  public modalWidgetSPCustomer2:string = "";
  public modalWidgetSPCustomer3:string = "";

  public merchantIds: any;
  public tpns: any;
  public merchantIdArray: any;  
  public element: boolean;
  public merchantData: any;
  public qryWhereTPN: any;
  public qryWhereTxBaseTPN: any;
  public allIsoData: any;
  public isoIdArray: any;
  public customerUnderISOMerchants: any;
  public qryWhereMerchant: any;
  public qryWhereOwnedByMerchant: any;   
  public qryWhereTotalMerchant: any;
  public qryWhereTotalOwnedByMerchant: any;
  public selectedISO: any;
  public selectedMerchant: any;
  public mccChartShow: boolean;
  public activityChartShow: boolean;
  public showTile: boolean;
  public longevityChartShow: boolean;
  public customActivityDays: any;
  public activityCardCustomDays: boolean;
  public notTransactedTPNCount: any;
  public customNTTPNDays: any;
  public NTTPNResult: any;
  public showNTTPNCard: boolean;
  public last30TVShow: boolean;
  public last30TCShow: boolean;
  public last30MerchantShow: boolean;   
  public last30CBShow: boolean;
  

  public lessSaleMerchantCount: any;
  public lessSaleMerchantResult: any;
  public customLSMdays: any;
  public customLSMAVGdays: any;
  public isMobileView: any;
  public isStateShow:boolean = false;
  public isChartShow:boolean = true;
  public isChart2Show:boolean = false;

  // Show card row tiles declaration
  public showTileTV: boolean;
  public showTileTC: boolean;
  public showTileMA: boolean;
  public showTileMD: boolean;
  public showTileMQ: boolean;
  public showTileCB: boolean;

  public lineChartConfig : Partial<apexChartOptions> = {
    series: [],
    chart: {
      type: "line",
      height: 'auto',
      width: '100%',
      stacked: false,
      events: {
        click: function (chart, w, e) {

        }
      },
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true
      }
    },
    responsive: [
      {
        breakpoint: 10,
        options: {
        }
      }
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "30%",
        distributed: true,
      }
    },
    colors: ['#9a17ff'],
    dataLabels: {
      enabled: true,
      enabledOnSeries: undefined,
      formatter: (val: any) => {
        return val === 0 ? '' : this.currency(val);
      },      
      textAnchor: 'middle',
      distributed: true,
      style: {
        colors: ['#000000'],
      }
    },
    grid: {
      show: true,
    },
    tooltip: {
      enabled: true,
      style: {  
        fontSize: '12px'
      },
      y: {
        formatter: function (data, opts) {
          return '$' + data.toLocaleString('en-US');
        }
      }
    },
    xaxis: {
      type: "category",
      categories: [],
      labels: {
        style: {
          fontSize: "12px"
        }
      },
    },
    legend: {
      show: false,
    },
    fill: {
      opacity: 1
    }
  };
  //Activity cards variable
  public activityCards =  {
    transactPercent : 0,
    nonTransactPercent : 0,
    numberOfTransactDays : 0
  }  
  public rawActivityData: any;  

  // Todays
  public todayTransactionsVolume: any;
  public todayTransactionsCount: any;
  public todayMerchantCount: any;
  public todayMerchantDeactivatedCount: any;

  // Merchant Count
  public totalMerchant: any;
  public lastMonthMerchant: any;
  public currentMonthMerchant: any;

  public todayTPNCount: any;
  public currentMonthTPN: any;
  public lastMonthTPN: any;
  public totalTPN: any;

  public totalMerchantDeactivated: any;
  public lastMonthMerchantDeactivated: any;
  public currentMonthMerchantDeactivated: any;

  public todayTPNDeactivatedCount: any;
  public currentMonthTPNDeactivated: any;
  public lastMonthTPNDeactivated: any;
  public totalTPNDeactivated: any;

  // Transactions Count
  public last3MonthTransactionsCount: any;
  public lastMonthTransactionsCount: any;
  public currentMonthTransactionsCount: any;

  // Transactions Volume
  public last3MonthTransactionsVolume: any;
  public lastMonthTransactionsVolume: any;
  public currentMonthTransactionsVolume: any;

  //Merchant Score cards variables
  public merchantInSystem: any;
  public daysFromLastTransact: any;
  public numberofStoreTpn: any;
  public merchantVolumeTrend: any;

  public numberOfStore: any;
  public numberOfTpn: any;
  public onMerchantSelected: boolean;
  public averageTicketSize: any;

  public thisMonthMerchantTitle: string;
  public lastMonthMerchantTitle: string;
  public totalMerchantTitle: string;
  public todayMerchantTitle: string;

  public thisMonthDeactiveMerchantTitle: string;
  public lastMonthDeactiveMerchantTitle: string;
  public totalDeactiveMerchantTitle: string;
  public todayDeactiveMerchantTitle: string;

  public thisMonthTransactionTitle: string;
  public title: string;
  public lastMonthTransactionTitle: string;
  public totalTransactionTitle: string;
  public todayTransactionTitle: String;

  public listIsoHierarchyStrParam: any;
  public listIsoHierarchyStr: any;
  public isSecondModalOpen: boolean;
  public isSPCustomerModalOpen: boolean;

  public todayCustomersCount: any;
  public thisMonthCustomersCount: any;
  public lastMonthCustomersCount: any;
  public overallCustomersCount: any;
  public thismonth: string;
  public lastmonth: string;
  public overall: string;
  public SPWiseCustomers: any;
  public SPCustShowDiv: boolean;
  public SPCustomerdtRange: any;
  public isLoading: boolean;

  public activity_total_mer: any;
  TimePeriodtoday:any = "Today"
  TimePeriodThismonth:any = "This Month"
  TimePeriodLastmoth:any = "Last Month"
  TimePeriodOverall:any = "Overall"

  selectedParentItem: any;
  selectedChildItem: any;
  modalTitle = '';
  loaderId = '';
  period = '';
  customersCount = 0;
  apexChartSPCustomers: Partial<apexChartOptions>;
  isShowLabel:boolean = true;
  viewByDevice:boolean = false

  DSSelected: string[] = ['val1','val3'];  //,'val5' - Merchant Quality Cards
  USstate = {'AL' :'Alabama',  'AK':'Alaska',  'AR':'Arkansas',  'AZ':'Arizona',  'CA':'California',  'CO':'Colorado',  'CT' :'Connecticut',  'DE':'Delaware',  'DC':'District of Columbia',  'FL' :'Florida',  'GA':'Georgia',  'HI' :'Hawaii',  'ID' :'Idaho',  'IL'  :'Illinois',  'IN' :'Indiana',  'IA' :'Iowa',  'KS':'Kansas',  'KY' :'Kentucky',  'LA' :'Louisiana',  'ME':'Maine',  'MD':'Maryland',  'MA':'Massachusetts',  'MI' :'Michigan',  'MN':'Minnesota',  'MS':'Mississippi',  'MO':'Missouri',  'MT':'Montana',  'NE':'Nebraska',  'NV':'Nevada',  'NH':'New Hampshire',  'NJ' :'New Jersey',  'NM':'New Mexico',  'NY' :'New York',  'NC':'North Carolina',  'ND':'North Dakota',  'OH':'Ohio',  'OK':'Oklahoma',  'OR':'Oregon',  'PA' :'Pennsylvania',  'RI' :'Rhode Island',  'SC':'South Carolina',  'SD':'South Dakota',  'TN' :'Tennessee',  'TX' :'Texas',  'UT' :'Utah',  'VT' :'Vermont',  'VA':'Virginia',  'WA':'Washington',  'WV':'West Virginia',  'WI':'Wisconsin',  'WY':'Wyoming', 'PR':'Puerto Rico'};

  public iposProcessor: any = 
  {
    'ZCRD' : 'Z Credit',
    'RS2U' : 'RS2 US',
    'FDOH' : 'Fiserv-Omaha',
    'TSYS' : 'TSYS',
    'RS2E' : 'RS2 Europe',
    'BPAY' : 'BridgePay',
    'WPAY' : 'WorldPay',
    'TSYS - TOP' : 'TSYS -Tap on Phone',
    'TSYS - MASTERCARD' : 'TSYS - Mastercard',
    'THST' : 'Test Host',
    'TSYS - VEGA' : 'TSYS - VEGA',
    'TSYS - EMV' : 'TSYS - EMV',
    'RSSU' : 'RS2 US Staging',
    'CKNX' : 'Cardknox',
    'ELVN' : 'Elavon',
    'FDRC' : 'Fiserv-North',
    'PNWX' : 'Paynetworx',
    'CASH' : 'Cash',
    'EGFT' : 'E-Gift',
    'SBAS' : 'Factor4',
    'STSH' : 'Smart Transaction Systems',
    'ACH' : 'Payrock ACH',    
    'VTEC' : 'ValueTech ',
    'PAYPAL' : 'Paypal',
    'RS2H' : 'RS2H',
    'TRUSTLY' : 'Trustly',
    'PAGO' : 'PAGO',
    'TRUSTLY SANDBOX' : 'Trustly Sandbox',
    'PAYPAL SANDBOX' : 'Paypal Sandbox',
    'WALLET' : 'Wallet',
    'ALIPAY' : 'Alipay',
    'VENMO BRAINTREE' : 'Venmo Braintree',
    'SensePass' : 'SensePass',
    'SensePos' : 'SensePass',
    'GIFT' : 'Gift',
    '' : 'Unknown'
  }

  public chartColors = [
    "#81d77999",
    "#9c1aff99",
    "#c2e68499",
    "#9c1aff4d",
    "#D10CE8",
    '#FF0000',  // RED
    '#00FFFF',  // Cyan 
    '#0000FF', // Blue
    // '#00008B', // Dark Blue
    // '#ADD8E6', // Ligh Blue
    '#800080', // Purple
    '#00008B', // Dark Blue
    '#FFFF00', // Yellow
    '#00FF00', // Lime
    '#FF00FF', // Magenta
    '#97A2D7', // Silver
    '#D798A3', // Pink
    '#FFD700', // Gold - yellow
    '#808080', // Grey
    '#000000', // Black
    '#FFA500', // Orange
    '#A52A2A', // Brown
    '#008000', // Green
    '#808000', // Olive
    '#800000', // Maroon
    '#7FFFD4', // Aquamarine
    '#FFE87C', // Sun Yellow
    '#806517', // Oak Brown
    '#ADD8E6' // Ligh Blue
  ]

  public chartDeviceColors = {"P3":"#81d77999",
    "Cloud POS":"#9c1aff99",
    "Apple Pay":"#c2e68499",
    "Tap On Phone":"#9c1aff4d",
    "QD5":"#D10CE8",
    "P1":"#FF0000",  // RED
    "P5":"#00FFFF",  // Cyan 
    "QD4":"#0000FF", // Blue
    // '#00008B', // Dark Blue
    // '#ADD8E6', // Ligh Blue
    "QD2":"#800080", // Purple
    "P8":'#00008B', // Dark Blue
    "QD3":'#FFFF00', // Yellow
    "P12":'#00FF00', // Lime
    "Q2":'#FF00FF', // Magenta
    "QD6":'#97A2D7', // Silver
    "QD1":'#D798A3', // Pink
    //"P10":'#FFD700', // Gold - yellow
    "P10":'#A52A2A', // Gold - yellow
    // '#808080', // Grey
    // '#000000', // Black
    // '#FFA500', // Orange
    // '#A52A2A', // Brown
    // '#008000', // Green
    // '#808000', // Olive
    // '#800000', // Maroon
    // '#7FFFD4', // Aquamarine
    // '#FFE87C', // Sun Yellow
    // '#806517', // Oak Brown
    // '#ADD8E6' // Ligh Blue
  }

  /**
   * NgbDatepicker
   */
  currentDate: NgbDateStruct;

  @ViewChild('ngSelectComponent') ngSelectComponent: NgSelectComponent;

  private dateFormat = "YYYY-MM-DD HH:mm:ss";
  clearData = [];
  //private localTZ = moment().format('Z');
  private localTZ = 'America/New_York';  // Default set to EDT|EST time-zone -04:00 offset
  private posResponseCode = "'00','10','11','85'";
  configUSChart: ZingchartAngular.graphset = {};
  chartUSMerchantTD : ZingchartAngular.graphset = {};
  chartUSMerchantTM : ZingchartAngular.graphset = {};
  chartUSMerchantLM : ZingchartAngular.graphset = {};
  chartUSMerchantOL : ZingchartAngular.graphset = {};

  constructor(private DashboardService: DashboardService, private messageService: MessageService, private modalService: NgbModal, private auth: AuthService, private ngxService: NgxUiLoaderService, private router: Router, private ngbModal:NgbModal, private commonService: CommonService, private platformLocation: PlatformLocation,private cdr: ChangeDetectorRef) {
    platformLocation.onPopState(() => this.ngbModal.dismissAll());
    this.apexChart1Options = {
      series: [{ name: '', data: [0, 0, 0, 0] }],
      chart: {
        type: "bar",
        //height: 'auto',
        height: 300,
        width: '100%',
        stacked: false,
        events: {
          click: function (chart, w, e) {

          }
        },
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: true
        }
      },
      // colors: [
      //   "#008FFB",
      //   "#00E396",
      //   "#FEB019",
      //   "#FF4560",
      //   "#775DD0",
      //   "#546E7A",
      //   "#26a69a",
      //   "#D10CE8"
      // ],
      responsive: [
        {
          breakpoint: 10,
          options: {
          }
        }
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          distributed: true,
        }
      },
      dataLabels: {
        enabled: true
      },
      grid: {
        show: true,
      },
      xaxis: {
        type: "category",
        categories: ["", "", ""],
        labels: {
          style: {
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            fontSize: "12px"
          }
        },
      },
      legend: {
        show: false,
      },
      fill: {
        opacity: 1
      }
    }
    this.apexChart2Options = this.apexChart1Options;
    this.apexChart3Options = this.apexChart1Options;
    this.apexChart4Options = this.apexChart1Options;
    this.apexChart5Options = this.apexChart1Options;
    this.apexChart6Options = this.apexChart1Options;
    this.apexChart7Options = this.apexChart1Options;
    this.apexChart8Options = this.apexChart1Options;
    this.apexChart9Options = this.apexChart1Options;
    this.apexChartTVDefault30 = this.apexChart1Options;
    this.apexChartTCDefault30 = this.apexChart1Options;
    this.apexChartDefaultMerchant30 = this.apexChart1Options;
    this.apexChartCBDefault30 = this.apexChart1Options;

    this.apexChart10Options = this.apexChart1Options;
    this.apexChart11Options = this.apexChart1Options;
    this.apexChart12Options = this.apexChart1Options;
    this.apexChart13Options = this.apexChart1Options;
    this.apexChart20Options = this.apexChart1Options;
    this.apexChart21Options = this.apexChart1Options;
    this.apexChart22Options = this.apexChart1Options;    
    this.apexChart23Options = this.apexChart1Options;
    this.apexChartMCCOptions = this.apexChart1Options;
    this.apexChartLongevityOptions = this.apexChart1Options;
    this.apexChartMDTodayOptions = this.apexChart1Options;
    this.apexChartSPCustomer = this.apexChart1Options;
    this.apexChartSPCustomer2 = this.apexChart1Options;
    this.apexChartSPCustomer3 = this.apexChart1Options;
    
    // Todays
    this.todayTransactionsVolume = 0;
    this.todayTransactionsCount = 0;
    this.todayMerchantCount = 0;
    this.todayMerchantDeactivatedCount = 0;

    // Merchant Count
    this.totalMerchant = 0;
    this.lastMonthMerchant = 0;
    this.currentMonthMerchant = 0;

    this.todayTPNCount = 0;
    this.currentMonthTPN = 0;
    this.lastMonthTPN = 0;
    this.totalTPN = 0;

    this.totalMerchantDeactivated = 0;
    this.lastMonthMerchantDeactivated = 0;
    this.currentMonthMerchantDeactivated = 0;

    this.todayTPNDeactivatedCount = 0;
    this.currentMonthTPNDeactivated = 0;
    this.lastMonthTPNDeactivated = 0;
    this.totalTPNDeactivated = 0;

    // Transactions Count
    this.last3MonthTransactionsCount = 0;
    this.lastMonthTransactionsCount = 0;
    this.currentMonthTransactionsCount = 0;
    // Transactions Volume
    this.last3MonthTransactionsVolume = 0;
    this.lastMonthTransactionsVolume = 0;
    this.currentMonthTransactionsVolume = 0;

    this.element = true;
    this.mccChartShow = true;
    this.activityChartShow = true;
    this.qryWhereTPN = '';
    this.qryWhereTxBaseTPN = '';
    this.qryWhereMerchant = '';
    this.qryWhereOwnedByMerchant = '';    
    this.qryWhereTotalMerchant = '';
    this.qryWhereTotalOwnedByMerchant = '';
    this.selectedISO = '';
    this.showTile = true;
    this.longevityChartShow = true;
    this.last30TVShow = false;
    this.last30TCShow = false;
    this.last30MerchantShow = false; 
    this.last30CBShow = false;

    //show card row tiles boolean assign
    this.showTileTV = true;
    this.showTileTC = false;
    this.showTileMA = true;
    this.showTileMD = false;
    this.showTileMQ = true;
    this.showTileCB = true;

    //Merchant Score cards variables
    this.merchantInSystem = 0;
    this.daysFromLastTransact = 0;
    this.numberofStoreTpn = 0;
    this.merchantVolumeTrend = 0;
    this.numberOfStore = 0;
    this.numberOfTpn = 0;
    this.onMerchantSelected = false;
    this.averageTicketSize = 0;

    this.thisMonthMerchantTitle = '[This Month] Merchant\'s / TPN\'s Acquisition';
    this.lastMonthMerchantTitle = '[Last Month] Merchant\'s / TPN\'s Acquisition';
    this.totalMerchantTitle = '[Overall] Merchant\'s / TPN\'s Acquisition';
    this.todayMerchantTitle = '[Today] Merchant\'s / TPN\'s Acquisition';

    this.thisMonthDeactiveMerchantTitle = 'Merchant Deactivated This Month';
    this.lastMonthDeactiveMerchantTitle = 'Merchant Deactivated Last Month';
    this.totalDeactiveMerchantTitle = 'Deactivated Merchant - Count';
    this.todayDeactiveMerchantTitle = 'TPN Deactivated Today';

    this.thisMonthTransactionTitle = 'Processing Volume - This Month';
    this.lastMonthTransactionTitle = 'Processing Volume - Last Month';
    this.totalTransactionTitle = 'Processing Volume - 12 Months';
    this.todayTransactionTitle = 'Processing Volume - Today';

    this.listIsoHierarchyStrParam = '';
    this.listIsoHierarchyStr = '';

    this.customActivityDays = 10;
    this.activityCardCustomDays = false;
    this.notTransactedTPNCount = 0;
    this.customNTTPNDays = 5;
    this.showNTTPNCard = false;

    this.lessSaleMerchantCount = 0;
    this.customLSMdays = 7;
    this.customLSMAVGdays = 90;    

    this.isSecondModalOpen = true;
    this.isSPCustomerModalOpen = true;

    this.todayCustomersCount = 0;
    this.thisMonthCustomersCount = 0;
    this.lastMonthCustomersCount = 0;
    this.overallCustomersCount = 0;

    this.thismonth='Customers Onboarding - This Month';
    this.lastmonth ='Customers Onboarding - Last Month';
    this.overall = 'Customers Onboarding - Last 12 Months';
    //this.SPWiseCustomers = '';
    this.SPCustomerdtRange = '';

  }
  currentUser:string;

  async ngOnInit(): Promise<any> {

    this.isMobileView = this.commonService.isMobileView;
    if ("DSSelected" in localStorage) {
      let retrievedObject = localStorage.getItem('DSSelected');
      this.DSSelected = JSON.parse(retrievedObject);
   

      (this.DSSelected.includes('val1')) ? this.showTileTV = true : this.showTileTV = false;
      (this.DSSelected.includes('val2')) ? this.showTileTC = true : this.showTileTC = false;
      (this.DSSelected.includes('val3')) ? this.showTileMA = true : this.showTileMA = false;
      (this.DSSelected.includes('val4')) ? this.showTileMD = true : this.showTileMD = false;
      (this.DSSelected.includes('val5')) ? this.showTileMQ = true : this.showTileMQ = false;

    } else {
      localStorage.setItem('DSSelected', JSON.stringify(this.DSSelected));
      let retrievedObject = localStorage.getItem('DSSelected');
      this.DSSelected = JSON.parse(retrievedObject);
    }

    this.merchantData = await this.getAllMerchants();
    this.merchantIds = '';
    this.merchantIdArray = this.merchantData.dropDownValues.sort((a,b) => a.dba.localeCompare(b.dba));
  

    // Getting All ISO's & Agents //
    this.allIsoData = await this.getAllISOs();
    this.isoIdArray = this.allIsoData.data.sort((a,b) => a.dba.localeCompare(b.dba));

    if (this.merchantIds == '') {      
      this.qryWhereTPN = '';
      this.qryWhereTxBaseTPN = '';
    }
    
    this.startAll();
  }

  setResults(electionResults, stateNames, colorGradient) {
    let stateResults: any = {};

    type State = {
      name: string;
      winningVotes: number;
      totalVotes: number;
      percent: number;
    };

    electionResults.forEach(function (state: State) {
      let stateName = state.name;
      //let colorIndex = state.winningVotes;
      let colorIndex = state.percent;
      let styleObject = {
        //backgroundColor: colorGradient[colorIndex - 6],
        backgroundColor: colorGradient[colorIndex],
        //group: colorIndex - 5,
        group: colorIndex,
        label: {
          text: state.name +'<br>'+ state.winningVotes,
          fontSize: '13px',
        },
        tooltip: {
          text: stateNames[stateName] + ' (' + state.winningVotes + ')',
          fontSize: '18px',
          textAlign: 'left',
          width: '200px',
          wrapText: true,
        },
      };
      stateResults[stateName] = styleObject;
    });

    return {
      backgroundColor: '#FFF',
      gui: {
        watermark: {
          position: 'tr',
        },
      },
      globals: {
        fontFamily: 'Open Sans Condensed',
        shadow: false,
      },
    
      legend: {
        backgroundColor: 'none',
        borderWidth: 0,
        offsetY: '-10px',
        toggleAction: 'none',
        verticalAlign: 'bottom',
        item: {
          fontSize: '16px',
        },
        marker: {
          type: 'rectangle',
          width: '20px',
          height: '10px',
        },
      },
      series: [
        // render legend items
        {
          legendItem: {
            text: '0-9%',
          },
          legendMarker: {
            backgroundColor: '#ccffcc',
          },
        },
        {
          legendItem: {
            text: '10-19%',
          },
          legendMarker: {
            backgroundColor: '#99ff99',
          },
        },
        {
          legendItem: {
            text: '20-29%',
          },
          legendMarker: {
            backgroundColor: '#33ff33',
          },
        },
        {
          legendItem: {
            text: '30-39%',
          },
          legendMarker: {
            backgroundColor: '#00cc00',
          },
        },
        {
          legendItem: {
            text: '40-49%',
          },
          legendMarker: {
            backgroundColor: '#006600',
          },
        },
        {
          legendItem: {
            text: '50-59%',
          },
          legendMarker: {
            backgroundColor: '#ffcc80',
          },
        },
        {
          legendItem: {
            text: '60-69%',
          },
          legendMarker: {
            backgroundColor: '#ffad33',
          },
        },
        {
          legendItem: {
            text: '70-79%',
          },
          legendMarker: {
            backgroundColor: '#ff9900',
          },
        },
        {
          legendItem: {
            text: '80-89%',
          },
          legendMarker: {
            backgroundColor: '#cc7a00',
          },
        },
        {
          legendItem: {
            text: '90-100%',
          },
          legendMarker: {
            backgroundColor: '#995c00',
          },
        },
      ],
      shapes: [
        // render map
        {
          type: 'zingchart.maps',
          options: {
            id: 'map',
            name: 'usa',
            scale: true,
            y: '60px',
            // width: '900px',
            // height: '900px',
            style: {
              borderColor: '#FFF',
              items: stateResults,
              hoverState: {
                alpha: 0.3,
                backgroundColor: '#FFF',
                borderWidth: '3px',
              },
            },
          },
        },
      ],
    };
  }

  DScheckbox() {
    localStorage.setItem('DSSelected', JSON.stringify(this.DSSelected));
    let retrievedObject = localStorage.getItem('DSSelected');
    this.DSSelected = JSON.parse(retrievedObject);

    (this.DSSelected.includes('val1')) ? this.showTileTV = true : this.showTileTV = false;
    (this.DSSelected.includes('val2')) ? this.showTileTC = true : this.showTileTC = false;
    (this.DSSelected.includes('val3')) ? this.showTileMA = true : this.showTileMA = false;
    (this.DSSelected.includes('val4')) ? this.showTileMD = true : this.showTileMD = false;
    (this.DSSelected.includes('val5')) ? this.showTileMQ = true : this.showTileMQ = false;

    if(this.showTileMD == true) {
      this.getTotalMerchantDeactivated();
    }
    //Metric cards
    if (this.showTileMQ == true) {
      this.getLongevityCard();
      if(this.showNTTPNCard == true) { this.getNotTransactTPN(); }
      this.getMCCCard();
      this.getActivityCard();
      //this.getActivityCard(this.activity_total_mer);      
      this.getLessSaleMerchants();
    }
  }

  callMerchantActivity(event) {
    //alert(`am at on change event => ${event}`);
    if(event.target.value < 3 || event.target.value > 30) { alert('Please select days between 3 - 30 days'); return; }
    this.customActivityDays = event.target.value;
    this.activityCardCustomDays = true;
    this.openModalWidgetActivity('', true);
  }

  refreshComponent() {
    if (this.element == true) {
      this.startAllMerchant();
    }
    this.startAllTransaction();
  }

  isPermission(privilege) {
    return this.userPrivilege.indexOf(privilege) != -1;
  }

  getUserType() {
    return this.auth.getUser.userType;
  }

  getPrivileges() {
    return this.auth.getPrivileges(Modules.USER).features;
  }

  startAll() {
    this.startAllTransaction();
    this.startAllMerchant();
  }

  startAllMerchant() {

    // Merchant Active Count
    this.getTotalMerchant();
    this.getLast30DaysMerchant();

    // Merchant Deactivated Count
    if (this.showTileMD == true) {
      this.getTotalMerchantDeactivated();
    }

    //Metric cards
    if (this.showTileMQ == true) {
      this.getLongevityCard();
      if(this.showNTTPNCard == true) { this.getNotTransactTPN(); }
      this.getMCCCard();
      this.getActivityCard();
      //this.getActivityCard(this.activity_total_mer);
      this.getLessSaleMerchants();
    }
  }

  startAllTransaction() {

    // Transactions Volume
    this.getLast3MonthTransactionsVolume();
    this.getLast30DaysTransactionVolume();
    this.getLast30DaysTransactionCount();
    if(this.showTileCB == true) {
      this.getTotalCustomers();
      this.getLast30DaysCustomersCount();
    }
  }

  async getAllMerchants() {
    try {
      const getAllMerchants = await this.DashboardService.getAllMerchants().pipe().toPromise();
      //return getAllMerchants.data;
      return getAllMerchants;
    } catch (err) {
      // this.showAlert(err, "error");
      return [];
    }
  }

  async getAllISOs() {
    try {
      const getAllISOs = await this.DashboardService.getAllISOs().pipe().toPromise();
      //return getAllISOs.data;
      return getAllISOs;
    } catch (err) {
      // this.showAlert(err, "error");
      return [];
    }
  }

  async getAllTpn() {
    this.element = false;
    
    this.tpns = await this.getTPNcount(this.merchantIds);
    await this.sleeper(500);
    this.merchantIds = this.merchantIds.map(item => "'" + item + "'").toString();
    

    if (this.onMerchantSelected == true) {  
      this.getMerchantInSystem();
      this.getMerchantStoreCount();
      this.getMerchantTpnCount();
      this.getMerchantLastTransactDays();
      this.getAverageTicketSize()
    }

    // Init Process Done
    if (this.merchantIds.length > 0 && this.tpns > 0) {
      this.startAllTransaction();
    }
  }

    /* Merchant dropdown select - on change event */
    getSelectedMerchant(getMerchantObj) {     
      if (isEmpty(getMerchantObj)) {                
        if (!isEmpty(this.selectedISO)) {
          this.onMerchantSelected = false;
          this.showTileCB = false;
          this.last30CBShow = false;
          this.getSelectedIso(this.selectedISO);
        } else {          
          this.clear(); 
        }     
      } else {
      this.element = false;
      this.merchantIds = [];
      this.selectedMerchant = '';      
      this.onMerchantSelected = true;
      // Todays
      this.todayTransactionsVolume = 0;
      this.todayTransactionsCount = 0;
      this.todayMerchantCount = 0;
      this.todayMerchantDeactivatedCount = 0;
  
      // Merchant Count
      this.totalMerchant = 0;
      this.lastMonthMerchant = 0;
      this.currentMonthMerchant = 0;
  
      this.todayTPNCount = 0;
      this.currentMonthTPN = 0;
      this.lastMonthTPN = 0;
      this.totalTPN = 0;
  
      this.totalMerchantDeactivated = 0;
      this.lastMonthMerchantDeactivated = 0;
      this.currentMonthMerchantDeactivated = 0;
  
      this.todayTPNDeactivatedCount = 0;
      this.currentMonthTPNDeactivated = 0;
      this.lastMonthTPNDeactivated = 0;
      this.totalTPNDeactivated = 0;
  
      // Transactions Count
      this.last3MonthTransactionsCount = 0;
      this.lastMonthTransactionsCount = 0;
      this.currentMonthTransactionsCount = 0;
      // Transactions Volume
      this.last3MonthTransactionsVolume = 0;
      this.lastMonthTransactionsVolume = 0;
      this.currentMonthTransactionsVolume = 0;
  
      //Merchant Score cards variables
      this.merchantInSystem = 0;
      this.daysFromLastTransact = 0;
      this.numberofStoreTpn = 0;
      this.merchantVolumeTrend = 0;
      this.numberOfStore = 0;
      this.numberOfTpn = 0;
      this.averageTicketSize = 0;

      this.last30TVShow = false;
      this.last30TCShow = false;
      this.last30MerchantShow = false;
      this.showTileCB = false;
      this.last30CBShow = false;

      this.selectedMerchant = getMerchantObj;

      if (!isEmpty(getMerchantObj.zipCode) && !isEmpty(zipcode_to_timezone.lookup( getMerchantObj.zipCode ))) {
        this.localTZ = zipcode_to_timezone.lookup( getMerchantObj.zipCode );
     
      }

      this.merchantIds.push(getMerchantObj.id);
      this.getAllTpn();
      }
    }

    /* ISO's dropdown select - on change event */
    async getSelectedIso(getIsoObj) {
      this.selectedChildItem = null; // Clear the child selection
      if (isEmpty(getIsoObj)) {    
        this.clear();      
      } else {     
        this.onMerchantSelected = false;
        this.merchantIdArray = [];
        this.activityChartShow = false;
        this.mccChartShow = false;
        this.last30TVShow = false;
        this.last30TCShow = false;
        this.last30MerchantShow = false;
        this.longevityChartShow = false;
        this.todayTransactionsVolume = 0;
        this.todayTransactionsCount = 0;
        // Transactions Count
        this.last3MonthTransactionsCount = 0;
        this.lastMonthTransactionsCount = 0;
        this.currentMonthTransactionsCount = 0;
        // Transactions Volume
        this.last3MonthTransactionsVolume = 0;
        this.lastMonthTransactionsVolume = 0;
        this.currentMonthTransactionsVolume = 0;

        this.todayMerchantCount = 0;
        this.todayMerchantDeactivatedCount = 0;
    
        // Merchant Count
        this.totalMerchant = 0;
        this.lastMonthMerchant = 0;
        this.currentMonthMerchant = 0;
    
        this.todayTPNCount = 0;
        this.currentMonthTPN = 0;
        this.lastMonthTPN = 0;
        this.totalTPN = 0;
    
        this.totalMerchantDeactivated = 0;
        this.lastMonthMerchantDeactivated = 0;
        this.currentMonthMerchantDeactivated = 0;
    
        this.todayTPNDeactivatedCount = 0;
        this.currentMonthTPNDeactivated = 0;
        this.lastMonthTPNDeactivated = 0;
        this.totalTPNDeactivated = 0;

        //Merchant Score cards variables
        this.merchantInSystem = 0;
        this.daysFromLastTransact = 0;
        this.numberofStoreTpn = 0;
        this.merchantVolumeTrend = 0;
        this.numberOfStore = 0;
        this.numberOfTpn = 0;
        this.averageTicketSize = 0;

        this.selectedMerchant = '';
        this.customActivityDays = 10;
        this.activityCardCustomDays = false;
        this.notTransactedTPNCount = 0;
        this.lessSaleMerchantCount = 0;
        this.showNTTPNCard = true;   
        this.showTileCB = false;     
        this.last30CBShow = false;
        this.isChart2Show = false;

        //this.ngSelectComponent?.handleClearClick();
        
        this.selectedISO = getIsoObj;
        this.customerUnderISOMerchants = await this.getAllCustomerUnderISO(getIsoObj.id);
        await this.sleeper(500);
        this.merchantIdArray = this.customerUnderISOMerchants.dropDownValues.sort((a,b) => a.dba.localeCompare(b.dba));
        this.merchantIds = this.customerUnderISOMerchants.data;

        let listIsoHierarchy = this.customerUnderISOMerchants.isoHierarchy;
        this.listIsoHierarchyStr = listIsoHierarchy.map(item => "'" + item + "'").toString();
        this.listIsoHierarchyStrParam = listIsoHierarchy.map(item => item).toString();        

        
        if (!isEmpty(this.merchantIds) && this.merchantIds.length>0) {          
          await this.getAllTpn();
          this.element = true;
          this.qryWhereMerchant = ` id IN (${this.merchantIds}) AND `;
          this.qryWhereOwnedByMerchant = ` ownedByMerchant IN (${this.merchantIds}) AND `;
          this.qryWhereTotalMerchant = ` WHERE id IN (${this.merchantIds}) `;
          this.qryWhereTotalOwnedByMerchant = ` WHERE ownedByMerchant IN (${this.merchantIds}) `;          
          this.startAllMerchant();
        } else {
          this.element = true;
        }

      }
    }    

    clearMerchantSelect() {
      this.ngSelectComponent?.handleClearClick();
    }

    sleeper = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

    async getAllCustomerUnderISO(bodyData: string[]) {
      try {
        const getAllCustomerUnderISO = await this.DashboardService.getAllCustomerUnderISO(bodyData).pipe().toPromise();
        return getAllCustomerUnderISO;
      } catch (err) {
        // this.showAlert(err, "error");
        return [];
      }
    }

    async getAllTransactions(bodyData: string[]) {
      try {
        const getAllTransactions = await this.DashboardService.getAllTransactions(bodyData).pipe().toPromise();
        return getAllTransactions.data;
      } catch (err) {
        // this.showAlert(err, "error");
        return [];
      }
    }

    async getTPNcount(bodyData: string[]) {
      try {
        const getTPNcount = await this.DashboardService.getTPNcount(bodyData).pipe().toPromise();
        return getTPNcount.data;
      } catch (err) {
        // this.showAlert(err, "error");
        return [];
      }
    }

    getMerchantInSystem() {
      const payLoad = {qry: 'getMerchantInSystem', merchantIds: this.merchantIds ? this.merchantIds : ''};
      this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
        (res) => {
          get(res, 'data', []).forEach((item, index) => {
            this.merchantInSystem = item.NoOfDays;
          });
          //this.ngxService.stopBackgroundLoader("loader-12");
        },
        (err) => {
          // this.showAlert(err, "error");
        }
      );
    }
  
    getMerchantStoreCount() {
      const query = `SELECT COUNT(*) as StoreCount FROM (SELECT id, LATEST(status, 12) as status FROM portal_stores WHERE merchantId = ${this.merchantIds} group by 1) WHERE status='ACTIVE'`;
      const payLoad = {qry: 'getMerchantStoreCount', merchantIds: this.merchantIds ? this.merchantIds : ''};
      this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
        (res) => {
          get(res, 'data', []).forEach((item, index) => {
            this.numberOfStore = item.StoreCount;
          });
          //this.ngxService.stopBackgroundLoader("loader-12");
        },      
        (err) => {
          // this.showAlert(err, "error");
        }
      );
    }
  
    getMerchantTpnCount() {
      //const queryTpnCount = `SELECT COUNT(*) as TPNCount FROM (SELECT id, LATEST(status, 12) as status FROM portal_tpns WHERE ownedByMerchant = ${this.merchantIds} group by 1) WHERE status='ACTIVE'`;
      const payLoad = {qry: 'getMerchantTpnCount', merchantIds: this.merchantIds ? this.merchantIds : ''};
      this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
        (res) => {
          get(res, 'data', []).forEach((item, index) => {
            this.numberOfTpn = item.TPNCount;
          });
        },      
        (err) => {
          // this.showAlert(err, "error");
        }
      );
    }
  
    getMerchantLastTransactDays() {
     
      const payLoad = {qry: 'getMerchantLastTransactDays', merchantIds: this.merchantIds ? this.merchantIds : ''};
      this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
        (res) => {
          get(res, 'data', []).forEach((item, index) => {
            this.daysFromLastTransact = item.NoOfDays;
          });
          //this.ngxService.stopBackgroundLoader("loader-12");
        },      
        (err) => {
          // this.showAlert(err, "error");
        }
      );
    }
  
    getAverageTicketSize() {
      //const query = `SELECT ROUND(SUM(totalAmount), 0) as totalVolume, COUNT(*) as totalCount FROM portal_tx_bases WHERE tpn in(${this.tpns}) AND posResponseCode IN (${this.posResponseCode}) ORDER BY 1 ASC`;
      // tpns: this.tpns ? this.tpns : ''
      const payLoad = {qry: 'getAverageTicketSize', merchantIds: this.merchantIds ? this.merchantIds : ''};
      this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
        (res) => {
          get(res, 'data', []).forEach((item, index) => {
            this.averageTicketSize = this.currency((item.totalVolume / item.totalCount).toFixed(2));
          });
        },
        (err) => {
          // this.showAlert(err, "error");
        }
      );
    }
  
    clear() {    

      this.todayTransactionsVolume = 0;
      this.todayTransactionsCount = 0;
      // Transactions Count
      this.last3MonthTransactionsCount = 0;
      this.lastMonthTransactionsCount = 0;
      this.currentMonthTransactionsCount = 0;
      // Transactions Volume
      this.last3MonthTransactionsVolume = 0;
      this.lastMonthTransactionsVolume = 0;
      this.currentMonthTransactionsVolume = 0;
      this.apexChart23Options = {};
      this.apexChartMCCOptions = {};      
      this.clearData=[];
      this.merchantIds = '';
      this.element = true;    
      this.onMerchantSelected = false;
      this.selectedISO = '';
      this.selectedMerchant = '';
      this.localTZ = 'America/New_York';  // Default set to EST/EDT timezone -04:00 offset
      this.customActivityDays = 10;
      this.activityCardCustomDays = false;
      this.notTransactedTPNCount = 0;
      this.lessSaleMerchantCount = 0;    
      this.showNTTPNCard = false;  
      this.showTileCB = true;
      this.listIsoHierarchyStr = '';
      this.isChart2Show = false;

      this.merchantIdArray = this.merchantData.dropDownValues.sort((a,b) => a.dba.localeCompare(b.dba));

      if (this.merchantIds == '') {        
        this.qryWhereTPN = '';
        this.qryWhereTxBaseTPN = '';
        this.qryWhereMerchant = '';
        this.qryWhereOwnedByMerchant = '';    
        this.qryWhereTotalMerchant = '';
        this.qryWhereTotalOwnedByMerchant = '';
        this.tpns = '';
      }      
      this.startAllTransaction();
      this.startAllMerchant();      
    }


  getMonth = (month = 0, year = null,) => {
    const months = ["", "Jan", "Feb", "Mar", "April", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    if (year) {
      try {
        return `${months[month]} - ${year.toString().replace("20", "")}`;
      } catch (e) {
        console.log("replace error", e);
        return `${months[month]}`;
      }
    } else {
      return `${months[month]}`;
    }
  }

  currency(labelValue) {
    // Nine Zeroes for Billions
    let currency: any = "";
    currency = (Math.abs(Number(labelValue)) >= 1.0e+9)
      ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + "B"
      // Six Zeroes for Millions 
      : (Math.abs(Number(labelValue)) >= 1.0e+6)
        ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + "M"
        // Three Zeroes for Thousands
        : (Math.abs(Number(labelValue)) >= 1.0e+3)
          ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(2) + "K"
          : Math.abs(Number(labelValue));

    return `$ ${currency}`;
  }

  numbering(labelValue) {
    // Nine Zeroes for Billions
    let currency: any = "";
    currency = (Math.abs(Number(labelValue)) >= 1.0e+9)
      ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + "B"
      // Six Zeroes for Millions 
      : (Math.abs(Number(labelValue)) >= 1.0e+6)
        ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + "M"
        // Three Zeroes for Thousands
        : (Math.abs(Number(labelValue)) >= 1.0e+3)
          ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(2) + "K"
          : Math.abs(Number(labelValue));

    return `${currency}`;
  }

  // Dashboard Settings
  openModalWidgetDS(content) {
    if (content) {
      this.modalService
        .open(content, { centered: true, size: "lg" })
        .result.then((result) => {
          this.modalWidgetDS = "Modal closed" + result;
        })
        .catch((res) => { });
    }
  }

  // Summary
  async openWidget1() {
    this.isChartShow = true;
    this.isStateShow = false;
    this.isChart2Show = false;
    this.viewByDevice = false;
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0101");

    const payLoad = {qry: 'openWidget1_Merchant', localTZ: this.localTZ, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
    const qryData = await this.getNewDashboardDataInfo(payLoad);

  
      if (qryData) {
        let rawData = qryData;
        let data = [];
        let tpnData = [];
        let series = [];
        let categories = [];

        // merchantIds: this.merchantIds ? this.merchantIds : '',
        const payLoad2 = {qry: 'openWidget1_TPN', localTZ: this.localTZ, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
        const qryData2 = await this.getNewDashboardDataInfo(payLoad2);

            let tpnRawData = qryData2;

        const emptyArrayOject = (day, week, month) =>  ({
          "perYear": 0,
          "perMonth": month,
          "perDay": day,
          "perWeek": week,
          "totalCount": 0
        })
        const modifiedTpnArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(0,0,i+1))
        const modifiedMerchantArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(0,0,i+1))
        for ( let i = 0 ; i < rawData.length ; i ++) {
          const perMonth = rawData[i].perMonth
          modifiedMerchantArray[perMonth-1] = rawData[i]
        }
        for (let i = 0; i < tpnRawData.length; i++) {
          const perMonth = tpnRawData[i].perMonth
          modifiedTpnArray[perMonth - 1] = tpnRawData[i]
        }

        const graphTpnArray = [...modifiedTpnArray]
        const graphMerchantArray = [...modifiedMerchantArray]
        let  modifiedIndex = -1
        for ( let i = 0 ; i < 31 ; i ++) {
            if( modifiedMerchantArray[i].totalCount == 0 && modifiedTpnArray[i].totalCount == 0) {
              modifiedIndex ++
              graphTpnArray.splice(i - modifiedIndex, 1);
              graphMerchantArray.splice(i - modifiedIndex, 1);
            }
        }

        let graphMerchantSortedArray = sortBy(graphMerchantArray, ['perYear','perMonth'])
        let graphTpnSortedArray = sortBy(graphTpnArray, ['perYear','perMonth'])

        graphMerchantSortedArray.forEach((item,index) => {
          data.push(item.totalCount);
          categories.push(`${thisClass.getMonth(item.perMonth, item.perYear)}`);
        });
        graphTpnSortedArray.forEach((item) => {
          tpnData.push(item.totalCount);

        });        

        series = [
          {
            name: "Merchant",
            data
          },
          {
            name: "TPN",
            data: tpnData
          }
        ];
        if (data.length > 0) {
          this.apexChart1Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: false,
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              "#81d77999",
              "#9c1aff99",
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                distributed: false,                
                dataLabels: {
                  position: 'top', // top, center, bottom
                }
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.numbering(val.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              offsetY: -20,
              //distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,              
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
            },
            title: {
              text: 'Trend view',
            }

          };
          this.ngxService.stopBackgroundLoader("loader-0101");
        }
      }

    //   },
    //   (err) => {
    //     // this.showAlert(err, "error");
    //   }
    // );
  }

  // Summary
  openWidget10(loaderId?:string) {
    this.openModalWidget15(null,loaderId);
  }
  async deviceWiseCount(period, isChart2Show, chartOption, localTZ, fromDate, endOfMonth) {
  
    let deviceWiseSeriesData = [];
    let deviceLabel = [];
    let deviceSeries = [];
  
    const deviceWiseCountPayload = {
      qry: 'deviceWiseCount',
      listIsoHierarchyStr: this.listIsoHierarchyStr ? this.listIsoHierarchyStr : '',
      onMerchantSelected: this.onMerchantSelected,
      localTZ, fromDate, endOfMonth, period,
    };
  
    const deviceWiseCountResult = await this.getNewDashboardDataInfo(deviceWiseCountPayload);
    if (deviceWiseCountResult) {
      let rawData = this.DashboardService.mergeByDeviceType(deviceWiseCountResult);
      const sum = rawData.reduce((acc, currentValue) => acc + currentValue.totalCount, 0);
  
      rawData.forEach(item => {
        deviceWiseSeriesData.push({
          name: item.deviceType,
          color: this.chartDeviceColors[item.deviceType],
          data: [((item.totalCount / sum) * 100).toFixed(2)],
        });
        deviceLabel.push(item.deviceType);
        deviceSeries.push(((item.totalCount / sum) * 100));
      });
       
      if (isChart2Show) {
        this[chartOption] = {
          series: deviceSeries,
          labels: deviceLabel,
          chart: { width: 550, type: "donut" },
          title: { text: 'View by devices' },
          legend: {
            show: true,
            showForSingleSeries: true,
            position: "right",
            formatter: function (legendName, opts) {
              return legendName + ' - ' + opts.w.globals.series[opts.seriesIndex].toFixed(2) + '%';
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
              return opts.w.globals.series[opts.seriesIndex].toFixed(2) + ' %';
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: function (val) {
                return val?.toFixed(2) + " %";
              },
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: { width: 200 },
                legend: { position: "bottom" },
              },
            },
          ],
        };
      } 
     } 
    this.cdr.detectChanges();
  }
  
  
  // Device Type
  async openWidget11(content,loaderId) {
    this.isChartShow = false;
    this.isChart2Show = true;
    this.isStateShow = false;
    this.viewByDevice = true;
    this.isLoading = true;
    
    const thisClass = this;
    if (this.totalTPN > 0 ) {
    this.ngxService.startBackgroundLoader(loaderId);
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    await this.deviceWiseCount("overAll",this.isChart2Show,"chart2ShowOption",this.localTZ,fromDate,endOfMonth)
    const payLoad = {qry: 'openWidget11', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
    const qryData = await this.getNewDashboardDataInfo(payLoad);
    
      if (qryData) {
        let rawData = qryData;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((deviceType, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                deviceType,
                perYear,
                perMonth,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, color: this.chartDeviceColors[item], data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart1Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              animations: {
                enabled: false
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "40%",
              }
            },
            title: {
              text: 'Last 12 months',
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          
        }
        // if(this.showNTTPNCard){
          if (content && series.length > 0) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget13 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        // }
        this.ngxService.stopBackgroundLoader(loaderId);
        this.isLoading = false;
      }
    }else{
      this.isLoading = false;
    }
  }

  async openModalWidget15(content,loaderId?:string) {  
    this.isLoading = true;  
    this.isChartShow = true;
    this.isStateShow = false;
    this.isChart2Show = false;
    this.viewByDevice = false;
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);

    const payLoad = {qry: 'openModalWidget15', listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
    const qryData = await this.getNewDashboardDataInfo(payLoad);
      if (qryData) {
        let rawData = qryData;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];        

        rawData.forEach(obj => {
          if (obj.customers_id === null) {
              obj.customers_id = "";
          }
          if (obj.isoCustomer === null) {
            obj.isoCustomer = "";
        }
        });
        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.id);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);          
        });

        series = data;

        if (data.length > 0) {
          this.apexChart1Options = {
            series: series,
            chart: {
              type: "donut",
              height: 'auto',
              width: '600',
              animations: {
                enabled: false,
              },
              events: {
                legendClick: (chartContext, seriesIndex, config) => {
                  const url = this.generateRouteURL(`merchant-management/list-merchant?customer=`+customerIdArr[seriesIndex]+`&isFilter=true`);    
                  window.open(decodeURIComponent(url), '_blank');
                }
              }
            },
            title: {
              text: 'By Customers'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            legend: {
              formatter: function(series, opts) {                
                return series + " - " + opts.w.globals.series[opts.seriesIndex] + " (tpn)";
              }
            },
          };          
          if (content && data.length > 0) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget1 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
          this.isLoading = false;
        }
      }
    this.ngxService.stopBackgroundLoader(loaderId);
  }

  // Summary
  async openWidget2() {
    this.isStateShow = false;
    this.isChartShow = true;
    this.isChart2Show = false;
    this.viewByDevice = false;
  
    this.ngxService.startBackgroundLoader("loader-0202");
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;

  
    const payLoad = {qry: 'openWidget2_Merchant', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
    const qryData = await this.getNewDashboardDataInfo(payLoad);

      if (qryData) {
        let rawData = qryData;
        let data = [];
        let tpnData = [];
        let series = [];
        let categories = [];

        // merchantIds: this.merchantIds ? this.merchantIds : '',
        const payLoad2 = {qry: 'openWidget2_TPN', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
        const qryData2 = await this.getNewDashboardDataInfo(payLoad2);

            let tpnRawData = qryData2;
    

        const emptyArrayOject = (day) =>  ({
          "perYear": 0,
          "perMonth": 0,
          "perDay": day,
          "perWeek": 0,
          "totalCount": 0
        })
        const modifiedTpnArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(i+1))
        const modifiedMerchantArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(i+1))
      
        for ( let i = 0 ; i < rawData.length ; i ++) {
          const perDay = rawData[i].perDay
          modifiedMerchantArray[perDay-1] = rawData[i]
        }
        for (let i = 0; i < tpnRawData.length; i++) {
          const perDay = tpnRawData[i].perDay
          modifiedTpnArray[perDay - 1] = tpnRawData[i]
        }

        const graphTpnArray = [...modifiedTpnArray]
        const graphMerchantArray = [...modifiedMerchantArray]
        let  modifiedIndex = -1
        for ( let i = 0 ; i < 31 ; i ++) {
            if( modifiedMerchantArray[i].totalCount == 0 && modifiedTpnArray[i].totalCount == 0) {
              modifiedIndex ++
              graphTpnArray.splice(i - modifiedIndex, 1);
              graphMerchantArray.splice(i - modifiedIndex, 1);
            }
        }

        graphMerchantArray.forEach((item,index) => {
          data.push(item.totalCount);
       
          categories.push(`${item.perDay}`);
        });
        graphTpnArray.forEach((item) => {
          tpnData.push(item.totalCount);
        });

        series = [
          {
            name: "Merchant",
            data
          },
          {
            name: "TPN",
            data: tpnData
          }
        ];
        if (data.length > 0) {
          this.apexChart2Options = {
            series: series,
            chart: {
              type: "line",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "40%",
                distributed: false,
                dataLabels: {
                  position: 'top', // top, center, bottom
                }
              }
            },
            colors:['#9c1aff99','#81d77999'],
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.numbering(val.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#000000"]
              },
              textAnchor: 'middle',
              //offsetY: -20,
              //distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top"
            },
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0202");
        }
      }
    //   },
    //   (err) => {
    //     // this.showAlert(err, "error");
    //   }
    // );
  }

  // Summary
  openWidget20(loaderId?:string) {
    this.openModalWidget25(null,loaderId);
  }

  // Device Type
  async openWidget21(content,loaderId) {
    this.isStateShow = false;
    this.isChartShow = false;
    this.isChart2Show = true;
    this.viewByDevice = true;
    this.isLoading = true;
    if (this.lastMonthTPN > 0) {
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);
    
    await this.deviceWiseCount("lastMonth",this.isChart2Show,"chart2MerchantLastMonth",this.localTZ,fromDate,endOfMonth)
   
    const payLoad = {qry: 'openWidget21', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
    const qryData = await this.getNewDashboardDataInfo(payLoad);
    if (qryData) {
        let rawData = qryData;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData, ['perMonth','perWeek'], ['asc','asc']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perWeek,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart2Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              intersect: false,
              shared: true,
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
              showForSingleSeries: true,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          if(this.showNTTPNCard){
            if (content && series.length > 0) {
              this.modalService
                .open(content, { centered: true, size: "lg" })
                .result.then((result) => {
                  this.modalWidget13 = "Modal closed" + result;
                })
                .catch((res) => { });
            }
          }
          this.ngxService.stopBackgroundLoader(loaderId);
        }
        this.isLoading = false;
    //   },
    //   (err) => {
    //     // this.showAlert(err, "error");
    //   }
    // );
   }
  } else{
    this.isLoading = false;
  }
  }

  openModalWidget25(content,loaderId?:string) {
    this.isLoading = true;
    this.isStateShow = false;
    this.isChart2Show = false;
    this.viewByDevice = false;
    this.isChartShow = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader(loaderId);
    
    const thisClass = this;
    const payLoad = {qry: 'openModalWidget25', localTZ: this.localTZ, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, fromDate, endOfMonth };
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.id);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
        });

        series = data;

        if (data.length > 0) {
          this.apexChart2Options = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {              
                  //window.open(`${environment.portalUrl}/merchant-management/list-merchant?customer=`+customerIdArr[seriesIndex]+`&isFilter=true&dateRange=lastMonth`, "_blank");
                  const url = this.generateRouteURL(`merchant-management/list-merchant?customer=`+customerIdArr[seriesIndex]+`&isFilter=true&dateRange=lastMonth`);
                  window.open(decodeURIComponent(url), '_blank');
                }
              }
            },
            title: {
              text: 'By Customers'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            legend: {
              formatter: function(series, opts) {
                //return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " / " + merchantData[opts.seriesIndex] + " (M)";
                return series + " - " + opts.w.globals.series[opts.seriesIndex] + " (tpn)";
              }
            },
          };
          if (content && data.length > 0) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget2 = "Modal closed" + result;
              })
              .catch((res) => { });
          }          
        }
        this.ngxService.stopBackgroundLoader(loaderId);
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
   //});
  }

  // Summary
  async openWidget3() {
    this.isChartShow = true;
    this.isStateShow = false;
    this.isChart2Show = false;
    this.viewByDevice = false;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader("loader-0303");
    const thisClass = this;

    const payLoad = {qry: 'openWidget3_Merchant', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
    const qryData = await this.getNewDashboardDataInfo(payLoad);
    
    if (qryData) {

        let rawData = qryData;
        let data = [];
        let series = [];
        let categories = [];
        let tpnData = [];
       
        const payLoad2 = {qry: 'openWidget3_TPN', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
        const qryData2 = await this.getNewDashboardDataInfo(payLoad2);
            let tpnRawData = qryData2;
      
        const emptyArrayOject = (day) =>  ({
          "perYear": 0,
          "perMonth": 0,
          "perDay": day,
          "totalCount": 0
        })
        const modifiedTpnArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(i+1))
        const modifiedMerchantArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(i+1))
    
        for ( let i = 0 ; i < rawData.length ; i ++) {
          const perDay = rawData[i].perDay
          modifiedMerchantArray[perDay-1] = rawData[i]
        }
        for (let i = 0; i < tpnRawData.length; i++) {
          const perDay = tpnRawData[i].perDay
          modifiedTpnArray[perDay - 1] = tpnRawData[i]
        }

        const graphTpnArray = [...modifiedTpnArray]
        const graphMerchantArray = [...modifiedMerchantArray]
        let  modifiedIndex = -1
        for ( let i = 0 ; i < 31 ; i ++) {
            if( modifiedMerchantArray[i].totalCount == 0 && modifiedTpnArray[i].totalCount == 0) {
              modifiedIndex ++
              graphTpnArray.splice(i - modifiedIndex, 1);
              graphMerchantArray.splice(i - modifiedIndex, 1);
            }
        }
        graphMerchantArray.forEach((item) => {
          data.push(item.totalCount);
          categories.push(`${item.perDay}`);
        });
        graphTpnArray.forEach((item) => {
          tpnData.push(item.totalCount);
        
        });

        series = [
          {
            name: "Merchant",
            data
          },
          {
            name: "TPN",
            data: tpnData,
          }          
        ];
      
        if (data.length > 0) {
          this.apexChart3Options = {
            series: series,
            chart: {
              type: "line",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: false,
              }
            },
            colors:['#9c1aff99','#81d77999'],
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              distributed: false,
              formatter: function (val, opts) {
                return thisClass.numbering(val.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#000000"]
              },
              textAnchor: 'middle',
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              title: {
                text: 'Day(s)',                
              },
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top"
            },
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0303");
        }
      }
   
  }

  // Summary
  openWidget30(loaderId?:string) {
    this.openModalWidget35(null,loaderId);
  }

  openModalWidget35(content,loaderId?:string) {
    this.isLoading = true;
    this.isChartShow = true;
    this.isStateShow = false;
    this.isChart2Show = false;
    this.viewByDevice = false;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader(loaderId);
    const thisClass = this;
    const payLoad = {qry: 'openModalWidget35', localTZ: this.localTZ, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, fromDate, endOfMonth };
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.id);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
        });

        series = data;

        if (data.length > 0) {
          this.apexChart3Options = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {
                  const url = this.generateRouteURL(`merchant-management/list-merchant?customer=`+customerIdArr[seriesIndex]+`&isFilter=true&dateRange=thisMonth`);
                  window.open(decodeURIComponent(url), '_blank');
                }
              }
            },
            title: {
              text: 'By Customers'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {                
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            legend: {
              formatter: function(series, opts) {
                return series + " - " + opts.w.globals.series[opts.seriesIndex] + " (tpn)";
              },
            },
          };
          if (content && data.length > 0) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget3 = "Modal closed" + result;
              })
              .catch((res) => { });
          }          
          
        }
        this.ngxService.stopBackgroundLoader(loaderId);
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }      
    );
   //});
  }

  openWidgetSPthisMonth() {
    this.isChartShow = true;
    this.isSecondModalOpen = true;
    this.isStateShow = false;
    this.isChart2Show = false;
    this.viewByDevice = false;
   
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0303");
   
    const payLoad = {qry: 'openWidgetSPthisMonth', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
        this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];
        let isoDBA = [];
        let isoCust = [];
        let isocid = [];

        rawData.forEach((item) => {
          if(item.salesPersonId === null) {
            item.salesPersonId = '';
          }
          if(item.isoCustomer === null) {
            item.isoCustomer = '';
          }
          if(item.isoDBA === null) {
            item.isoDBA = '';
          }
        });

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.salesPersonId);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
          isoDBA.push(item.customersCount);
          //isoCust.push(item.isoDBA);
          isocid.push(item.cid);
        });

        series = data;

        if (data.length > 0) {
          this.apexChart3Options = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {
                  let ccid = isocid[seriesIndex].split(",");
                  ccid = ccid.map(item=> "'"+item+"'").toString();
                            
                  if (this.isSecondModalOpen) {
                    this.getSPQuery(ccid, categories[seriesIndex]);
                  }
		              
                }
              }
            },
            title: {
              text: 'By Salesperson'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {                
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            tooltip: {
            },
            legend: {
              formatter: function(series, opts) {
                return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " (tpn) / " + isoDBA[opts.seriesIndex] + " (customers)";
              },
              fontSize: '14px',
            },
          };       
          this.ngxService.stopBackgroundLoader("loader-0303");
        } else {
          this.apexChart3Options = this.apexChart1Options;
          this.isChartShow = false;
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
   //});
  }

  openWidgetSPtoday() {
    this.isChartShow = true;
    this.isStateShow = false;
    this.isChart2Show = false;
    this.viewByDevice = false;
    this.isSecondModalOpen = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('day').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-1515");

    //const query = `SELECT customers.salesPersonId, users.firstName as isoCustomer, COUNT(DISTINCT(tpn.ownedByMerchant)) as totalMerCount, COUNT(tpn.tpn) as totalCount, COUNT(DISTINCT customers.id) as customersCount,  STRING_AGG(DISTINCT customers.id, ',', 2000) as cid FROM portal_tpns tpn INNER JOIN portal_customers customers ON customers.id=tpn.ownedByCustomer INNER JOIN portal_users users ON users.id = customers.salesPersonId WHERE ${this.qryWhereOwnedByMerchant} tpn.status='ACTIVE' AND TIME_FORMAT(tpn.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND tpn.tpn NOT IN (SELECT tpn from portal_tpns WHERE status = 'DEACTIVATED') GROUP BY 1,2 ORDER BY 4 ASC`;
    //merchantIds: this.merchantIds ? this.merchantIds : '',
    const payLoad = {qry: 'openWidgetSPtoday', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
        this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];
        let isoDBA = [];
        let isoCust = [];
        let isocid = [];

        rawData.forEach((item) => {
          if(item.salesPersonId === null) {
            item.salesPersonId = '';
          }
          if(item.isoCustomer === null) {
            item.isoCustomer = '';
          }
          if(item.isoDBA === null) {
            item.isoDBA = '';
          }
        });

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.salesPersonId);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
          isoDBA.push(item.customersCount);
          //isoCust.push(item.isoDBA);
          isocid.push(item.cid);
        });

        series = data;

        if (data.length > 0) {
          this.apexChart13Options = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {
                  let ccid = isocid[seriesIndex].split(",");
                  ccid = ccid.map(item=> "'"+item+"'").toString();
                  if (this.isSecondModalOpen) {
                    this.getSPQuery(ccid, categories[seriesIndex]);
                  }
                }
              }
            },
            title: {
              text: 'By Salesperson'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {                
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            legend: {
              formatter: function(series, opts) {
                return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " (tpn) / " + isoDBA[opts.seriesIndex] + " (customers)";
              },
              fontSize: '14px',
            },
          };      
          this.ngxService.stopBackgroundLoader("loader-1515");
        } else {
          this.apexChart13Options = this.apexChart1Options;
          this.isChartShow = false;
        }
      },      
      (err) => {
        // this.showAlert(err, "error");
      }      
    );
   //});
  }

  openWidgetSPlastMonth() {
  
    this.isChartShow = true;
    this.isStateShow = false;
    this.isChart2Show = false;
    this.viewByDevice = false;
    this.isSecondModalOpen = true;
   
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0202");
    
    const payLoad = {qry: 'openWidgetSPlastMonth', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
        this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];
        let isoDBA = [];
        let isoCust = [];
        let isocid = [];

        rawData.forEach((item) => {
          if(item.salesPersonId === null) {
            item.salesPersonId = '';
          }
          if(item.isoCustomer === null) {
            item.isoCustomer = '';
          }
          if(item.isoDBA === null) {
            item.isoDBA = '';
          }
        });

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.salesPersonId);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
          isoDBA.push(item.customersCount);
          //isoCust.push(item.isoDBA);
          isocid.push(item.cid);
        });

        series = data;

        if (data.length > 0) {
          this.apexChart2Options = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {
                  let ccid = isocid[seriesIndex].split(",");
                  ccid = ccid.map(item=> "'"+item+"'").toString();
                  if (this.isSecondModalOpen) {
                    this.getSPQuery(ccid, categories[seriesIndex]);
                  }
                }
              }
            },
            title: {
              text: 'By Salesperson'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {                
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            legend: {
              formatter: function(series, opts) {
                return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " (tpn) / " + isoDBA[opts.seriesIndex] + " (customers)";
              },
              fontSize: '14px',  
            },
          };
          this.ngxService.stopBackgroundLoader("loader-0202");
        } else {
          this.apexChart2Options = this.apexChart1Options;
          this.isChartShow = false;
        }        
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
   //});
  }

  openWidgetSPtotal() {
   
    this.isChartShow = true;
    this.isStateShow = false;
    this.isSecondModalOpen = true;
    this.isChart2Show = false;
    this.viewByDevice = false;
  
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0101");

    const payLoad = {qry: 'openWidgetSPtotal', listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];
        let isoDBA = [];
        let isoCust = [];
        let isocid = [];

        rawData.forEach((item) => {
          if(item.salesPersonId === null) {
            item.salesPersonId = '';
          }
          if(item.isoCustomer === null) {
            item.isoCustomer = '';
          }
          if(item.isoDBA === null) {
            item.isoDBA = '';
          }
        });

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.salesPersonId);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
          isoDBA.push(item.customersCount);
          //isoCust.push(item.isoDBA);
          isocid.push(item.cid);
        });

        series = data;

        if (data.length > 0) {
          this.apexChart1Options = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {
                  let ccid = isocid[seriesIndex].split(",");
                  ccid = ccid.map(item=> "'"+item+"'").toString();
                  if (this.isSecondModalOpen) {
                    this.getSPQuery(customerIdArr[seriesIndex], categories[seriesIndex], 'true');
                  }
                }
              }
            },
            title: {
              text: 'By Salesperson'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {                
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            tooltip: {
              
            },
            legend: {
              formatter: function(series, opts) {
                return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " (tpn) / " + isoDBA[opts.seriesIndex] + " (customers)";  
              },
              fontSize: '14px',
            },
          };
          this.ngxService.stopBackgroundLoader("loader-0101");
        } else {
          this.apexChart1Options = this.apexChart2Options;
          this.isChartShow = false;
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
   //});
  }

  // Merchant Deactivated - Salesperson charts
  openWidgetSPthisMonthMD() {
    this.isChartShow = true;
   
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.thisMonthMerchantTitle = 'TPN added by customer(s) this month';
    this.ngxService.startBackgroundLoader("loader-1212");

    const thisClass = this;
    
    const payLoad = {qry: 'openWidgetSPthisMonthMD', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];
        let isoDBA = [];
        let isoCust = [];

        rawData.forEach((item) => {
          if(item.customers_salesPersonId === null) {
            item.customers_salesPersonId = '';
          }
          if(item.isoCustomer === null) {
            item.isoCustomer = '';
          }
          if(item.isoDBA === null) {
            item.isoDBA = '';
          }
        });

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.salesPersonId);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
          isoDBA.push(item.customersCount);
          isoCust.push(item.isoDBA);
        });

        series = data;

        if (data.length > 0) {
          this.apexChart12Options = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {
                }
              }
            },
            title: {
              text: 'By Salesperson'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {                
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            tooltip: {
              custom: function({series, seriesIndex, dataPointIndex, w}) {
                return '<div class="arrow_box" style="padding-left:10px; padding-right:10px; border-style:groove">' +
                  '<span>' + categories[seriesIndex] + ' - ' + data[seriesIndex]+' (tpn) <br><u>Customers: -</u><br>'+ isoCust[seriesIndex] + '</span>' +
                  '</div>'
              },
              theme: 'light',
            },
            legend: {
              formatter: function(series, opts) {
                return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " (tpn) / " + isoDBA[opts.seriesIndex] + " (customers)";
              },
              fontSize: '14px',
            },
          };
                 
          this.ngxService.stopBackgroundLoader("loader-1212");
        } else {
          this.apexChart12Options = this.apexChart1Options;
          this.isChartShow = false;
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
   //});
  }

  openWidgetSPtodayMD() {
    this.openModalWidgetMDToday(null);
  }

  openModalWidgetMDToday(content) {
    this.isChartShow = true;
    this.isLoading = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('day').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
    this.thisMonthMerchantTitle = 'TPN added by this month';
    const thisClass = this;
    this.ngxService.startBackgroundLoader('loader-16')
  
    const payLoad = {qry: 'openWidgetSPtodayMD', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];
        let isoDBA = [];
        let isoCust = [];

        rawData.forEach((item) => {
          if(item.customers_salesPersonId === null) {
            item.customers_salesPersonId = '';
          }
          if(item.isoCustomer === null) {
            item.isoCustomer = '';
          }
          if(item.isoDBA === null) {
            item.isoDBA = '';
          }
        });

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.salesPersonId);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
          isoDBA.push(item.customersCount);
          isoCust.push(item.isoDBA);
        });

        series = data;

        if (data.length > 0) {
          this.apexChartMDTodayOptions = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {
                  
                }
              }
            },
            title: {
              text: 'By Salesperson'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {                
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            tooltip: {
              custom: function({series, seriesIndex, dataPointIndex, w}) {
                return '<div class="arrow_box" style="padding-left:10px; padding-right:10px; border-style:groove">' +
                  '<span>' + categories[seriesIndex] + ' - ' + data[seriesIndex]+' (tpn) <br><u>Customers: -</u><br>'+ isoCust[seriesIndex] + '</span>' +
                  '</div>'
              },
              theme: 'light',
            },
            colors:['#9c1aff99','#81d77999'],
            legend: {
              formatter: function(series, opts) {
                return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " (tpn) / " + isoDBA[opts.seriesIndex] + " (customers)";
              },
              fontSize: '14px',
            },
          };          
        } else {
          this.apexChartMDTodayOptions = this.apexChart1Options;
          this.isChartShow = false;
        }
        if (content && data.length > 0) {
          this.modalService
            .open(content, { centered: true, size: "lg" })
            .result.then((result) => {
              this.modalWidgetMDToday = "Modal closed" + result;
            })
            .catch((res) => { });
        }
        this.ngxService.stopBackgroundLoader('loader-16')
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }      

    );
  }

  openWidgetSPlastMonthMD() {
    this.isChartShow = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.thisMonthMerchantTitle = 'TPN added by customer(s) this month';
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-1111");

    const payLoad = {qry: 'openWidgetSPlastMonthMD', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];
        let isoDBA = [];
        let isoCust = [];

        rawData.forEach((item) => {
          if(item.customers_salesPersonId === null) {
            item.customers_salesPersonId = '';
          }
          if(item.isoCustomer === null) {
            item.isoCustomer = '';
          }
          if(item.isoDBA === null) {
            item.isoDBA = '';
          }
        });

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.salesPersonId);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
          isoDBA.push(item.customersCount);
          isoCust.push(item.isoDBA);
        });

        series = data;

        if (data.length > 0) {
          this.apexChart11Options = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {
                }
              }
            },
            title: {
              text: 'By Salesperson'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {                
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            tooltip: {
              custom: function({series, seriesIndex, dataPointIndex, w}) {
                return '<div class="arrow_box" style="padding-left:10px; padding-right:10px; border-style:groove">' +
                  '<span>' + categories[seriesIndex] + ' - ' + data[seriesIndex]+' (tpn) <br><u>Customers: -</u><br>'+ isoCust[seriesIndex] + '</span>' +
                  '</div>'
              },
              theme: 'light',
            },
            legend: {
              formatter: function(series, opts) {
                //return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " / " + merchantData[opts.seriesIndex] + " (M)";
                return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " (tpn) / " + isoDBA[opts.seriesIndex] + " (customers)";
                //return series + " - " + opts.w.globals.series[opts.seriesIndex] + " (tpn)";
              },
              fontSize: '14px',  
            },
          };
          this.ngxService.stopBackgroundLoader("loader-1111");
        } else {
          this.apexChart11Options = this.apexChart1Options;
          this.isChartShow = false;
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
   //});
  }

  openWidgetSPtotalMD() {
 
    this.isChartShow = true;
    this.thisMonthMerchantTitle = 'TPN added by customer(s) this month';
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-1010");
    
    const payLoad = {qry: 'openWidgetSPtotalMD', listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];
        let data = [];
        let merchantData = [];
        let customerIdArr = [];
        let isoDBA = [];
        let isoCust = [];
        let isocid = [];

        rawData.forEach((item) => {
          if(item.customers_salesPersonId === null) {
            item.customers_salesPersonId = '';
          }
          if(item.isoCustomer === null) {
            item.isoCustomer = '';
          }
          if(item.isoDBA === null) {
            item.isoDBA = '';
          }
        });

        rawData = orderBy(rawData,['totalCount'],['desc']);

        rawData.forEach((item,index) => {
          customerIdArr.push(item.salesPersonId);
          data.push(item.totalCount);
          merchantData.push(item.totalMerCount);
          categories.push(item.isoCustomer);
          isoDBA.push(item.customersCount);
          isoCust.push(item.isoDBA);
          //isocid.push(item.cid);
        });

        series = data;

        if (data.length > 0) {
          this.apexChart10Options = {
            series: series,
            chart: {
              type: "donut",
              width: '600',
              events: {
                legendClick: (chartContext, seriesIndex, config) => {               
                }
              }
            },
            title: {
              text: 'By Salesperson'
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      formatter: function (val) {
                        return truncate(val,{'length':10, 'separator':'...'});
                      }
                    },
                    total: {
                      showAlways: true,
                      show: true,
                      fontWeight: 'bold',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            labels: categories,
            dataLabels: {
              enabled: true,
              formatter: function(data, opts) {                
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            tooltip: {
              custom: function({series, seriesIndex, dataPointIndex, w}) {
                return '<div class="arrow_box" style="padding-left:10px; padding-right:10px; border-style:groove;">' +
                  '<span>' + categories[seriesIndex] + ' - ' + data[seriesIndex]+' (tpn) <br><u>Customers: -</u><br>'+ isoCust[seriesIndex] + '</span>' +
                  '</div>'
              },
              theme: 'light',
            },
            legend: {
              formatter: function(series, opts) {
                return series + " - " + opts.w.globals.series[opts.seriesIndex]  + " (tpn) / " + isoDBA[opts.seriesIndex] + " (customers)";
              },
              fontSize: '14px',
            },
          };
          this.ngxService.stopBackgroundLoader("loader-1010");
        } else {
          this.apexChart10Options = this.apexChart1Options;
          this.isChartShow = false;
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
   //});
  }

  // Channel
  async openWidget33(content,loaderId) {
   
    this.isChartShow = false;
    this.isStateShow = false;
    this.isChart2Show = true;
    this.viewByDevice = true;
    const thisClass = this;
    this.isLoading = true;
    if (this.currentMonthTPN > 0) {
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader(loaderId);
    await this.deviceWiseCount("thisMonth",this.isChart2Show,"chart2MerchantThisMonth",this.localTZ,fromDate,endOfMonth)
    const payLoad = {qry: 'openWidget33', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    const qryData = await this.getNewDashboardDataInfo(payLoad);
    // this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      // (res) => {
      if(qryData){
        let rawData = qryData;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData, ['perMonth','perDay'], ['asc','asc']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perDay,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart3Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
              showForSingleSeries: true,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          if(this.showNTTPNCard){
            if (content && series.length > 0) {
              this.modalService
                .open(content, { centered: true, size: "lg" })
                .result.then((result) => {
                  this.modalWidget13 = "Modal closed" + result;
                })
                .catch((res) => { });
            }
          }
          this.ngxService.stopBackgroundLoader(loaderId);
          this.isLoading = false;
        }
      }
    } else {
    this.isLoading = false;
    }
  }

  // US geo map merchants distribution using zipcode...
  openWidget34MerchantGeoMap(dtRange='') {
    let nowUTC = moment().utc();
    this.isChartShow = false;
    this.isStateShow = true;
    this.isChart2Show = false;
    this.viewByDevice = false;
    let query;
    const thisClass = this;

    this.ngxService.startBackgroundLoader("loader-0303");
    
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
   
    const payLoad = {qry: 'openWidget34MerchantGeoMap', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        if (rawData.length > 0) {   
          let groupedCityArray = this.groupCityArray(rawData);
          let groupedStateArray = this.groupStateArray(rawData);
          let oStates = this.getUSStateArray(groupedStateArray);
          let oCities = this.getLatLongArray(groupedCityArray);   // rawData     
          this.chartUSMerchantTM = this.callBrazilChart(oStates);
          for (let city in oCities) {
            // save xy position
            oCities[city].x = oCities[city].longitude + 'lon';
            oCities[city].y = oCities[city].latitude + 'lat';
            this.chartUSMerchantTM.shapes.push(this.drawCity(city, oCities));
          }
        }
      },
      (err) => {
        this.showAlert(err, "error");
      }
    );  
    this.ngxService.stopBackgroundLoader("loader-0303");
  }

  openWidget24MerchantGeoMap(dtRange='') {
  
    let nowUTC = moment().utc();
    this.isChartShow = false;
    this.isChart2Show = false;
    this.isStateShow = true;
    this.viewByDevice = false;
    let query;
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0202");
    
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    
    const payLoad = {qry: 'openWidget24MerchantGeoMap', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        if (rawData.length > 0) {          
          let groupedCityArray = this.groupCityArray(rawData);
          let groupedStateArray = this.groupStateArray(rawData);
          let oStates = this.getUSStateArray(groupedStateArray);
          let oCities = this.getLatLongArray(groupedCityArray);      
          this.chartUSMerchantLM = this.callBrazilChart(oStates);
          for (let city in oCities) {
            // save xy position
            oCities[city].x = oCities[city].longitude + 'lon';
            oCities[city].y = oCities[city].latitude + 'lat';
            this.chartUSMerchantLM.shapes.push(this.drawCity(city, oCities));
          }
        }
      },
      (err) => {
        this.showAlert(err, "error");
      }
    );
    this.ngxService.stopBackgroundLoader("loader-0202");
  }

  openWidget14MerchantGeoMap(dtRange='') {
    let nowUTC = moment().utc();
    this.isChartShow = false;
    this.isChart2Show = false;
    this.isStateShow = true;
    this.viewByDevice = false;
    let query;
    let endOfMonth;
    let fromDate;
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0101");
    const payLoad = {qry: 'openWidget14MerchantGeoMap', fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        if (rawData.length > 0) {
          let groupedCityArray = this.groupCityArray(rawData);
          let groupedStateArray = this.groupStateArray(rawData);
          let oStates = this.getUSStateArray(groupedStateArray);          
          let oCities = this.getLatLongArray(groupedCityArray);      
          this.chartUSMerchantOL = this.callBrazilChart(oStates);
          for (let city in oCities) {
            // save xy position
            oCities[city].x = oCities[city].longitude + 'lon';
            oCities[city].y = oCities[city].latitude + 'lat';
            this.chartUSMerchantOL.shapes.push(this.drawCity(city, oCities));
          }
        }
      },
      (err) => {
        this.showAlert(err, "error");
      }
    );
    this.ngxService.stopBackgroundLoader("loader-0101");
  }

 
  // Merchant Today card - chart modal open window

  openWidget130(loaderId?:string) {
    this.openModalWidget13(null,loaderId);
  }

  openModalWidget13(content,loaderId?:string) {
    this.isLoading = true;
    this.isChartShow = true;
    this.isStateShow = false;
    this.isChart2Show = false;
    this.viewByDevice = false;
    const thisClass = this;
    
    if (this.todayTPNCount > 0) {
      let nowUTC = moment().utc();
      let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
      let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
      this.ngxService.startBackgroundLoader(loaderId);
          
          const payLoad = {qry: 'openModalWidget13', localTZ: this.localTZ, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, fromDate, endOfMonth};
          this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
            (res) => {
              let rawData = get(res, 'data', []);

              let series = [];
              let categories = [];
              let gropingDataType = [];
              let templateData = [];
              let data = [];
              let merchantData = [];
              let customerIdArr = [];

              rawData = orderBy(rawData, ['totalCount'], ['desc']);

              rawData.forEach((item, index) => {
                customerIdArr.push(item.id);
                data.push(item.totalCount);
                merchantData.push(item.totalMerCount);
                categories.push(item.isoCustomer);
              });

              series = data;

              if (data.length > 0) {
                this.apexChart13Options = {
                  series: series,
                  chart: {
                    type: "donut",
                    width: '600',
                    events: {
                      legendClick: (chartContext, seriesIndex, config) => {
                        const url = this.generateRouteURL(`merchant-management/list-merchant?customer=` + customerIdArr[seriesIndex] + `&isFilter=true&dateRange=Today`);
                        window.open(decodeURIComponent(url), '_blank');
                      }
                    }
                  },
                  title: {
                    text: 'By Customers'
                  },
                  plotOptions: {
                    pie: {
                      donut: {
                        labels: {
                          show: true,
                          name: {
                            formatter: function (val) {
                              return truncate(val, { 'length': 10, 'separator': '...' });
                            }
                          },
                          total: {
                            showAlways: true,
                            show: true,
                            fontWeight: 'bold',
                            color: '#373d3f',
                          }
                        }
                      }
                    }
                  },
                  labels: categories,
                  dataLabels: {
                    enabled: true,
                    formatter: function (data, opts) {
                      return opts.w.globals.series[opts.seriesIndex];
                    }
                  },
                  legend: {
                    formatter: function (series, opts) {
                      return series + " - " + opts.w.globals.series[opts.seriesIndex] + " (tpn)";
                    },
                  },
                };
                if (content && data.length > 0) {
                  this.modalService
                    .open(content, { centered: true, size: "lg" })
                    .result.then((result) => {
                      this.modalWidget13 = "Modal closed" + result;
                    })
                    .catch((res) => { });
                }
              }
              this.ngxService.stopBackgroundLoader(loaderId);
              this.isLoading = false; 
            },
            (err) => {
              // this.showAlert(err, "error");
            }
          );
        }
     else{
      this.isLoading = false;
     }   
  }

  async openWidget131(content,loaderId) {
    this.isChartShow = false;
    this.isStateShow = false;
    this.isChart2Show = true;
    this.viewByDevice = true;
    const thisClass = this;
    if (this.todayTPNCount > 0) {
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('day').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
    this.ngxService.startBackgroundLoader(loaderId);
    await this.deviceWiseCount("today",this.isChart2Show,"chart2MerchantToday",this.localTZ,fromDate,endOfMonth)
    const payLoad = {qry: 'openWidget131', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    const qryData = await this.getNewDashboardDataInfo(payLoad);
    if(qryData) {
        let rawData =qryData;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perDay,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart13Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
              showForSingleSeries: true,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          if(this.showNTTPNCard){
            if (content && series.length > 0) {
              this.modalService
                .open(content, { centered: true, size: "lg" })
                .result.then((result) => {
                  this.modalWidget13 = "Modal closed" + result;
                })
                .catch((res) => { });
            }
          }
          this.ngxService.stopBackgroundLoader(loaderId);
        }
    }
  }else{
    this.isLoading = false;
  }  
  }

  // Summary
  openModalWidget4(content,loaderId?:string) {
    this.isLoading = true;
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);

    
    const payLoad = {qry: 'openModalWidget4', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item) => {
          data.push(item.totalCount);
          categories.push(`${thisClass.getMonth(item.perMonth, item.perYear)}`);
        });        
        series = [
          {
            name: "Count",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart4Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "40%",
                distributed: true,
                dataLabels: {
                  position: 'top',
                  hideOverflowingLabels: false
                }
              }
            },
            dataLabels: {
              enabled: true,
              style: {
                fontSize: '12px',
                colors: ['#304758']
              },
              textAnchor: 'middle',
              offsetY: -20,
              formatter: function (data, opts) {
                return thisClass.numbering(data.toString());
              }
            },
            colors: [
              "#81d77999",
              "#9c1aff99",
              "#c2e68499",
              "#9c1aff4d",
              "#D10CE8",
              "#008FFB",
              "#00E396",
              "#FEB019",
              "#FF4560",
              "#775DD0",
              "#546E7A",
              "#26a69a",
              "#D10CE8"
            ],
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function(data) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget4 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
        this.ngxService.stopBackgroundLoader(loaderId);
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openWidget40(loaderId?:string) {
    this.openModalWidget4(null,loaderId);
  }

  // Device Type
  openWidget41() {
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0404");

    
    const payLoad = {qry: 'openWidget41', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((deviceType, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                deviceType,
                perYear,
                perMonth,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart4Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0404");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Card Type
  openWidget42() {
  
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0404");

   
    const payLoad = {qry: 'openWidget42', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'cardLabel');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((cardLabel, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                cardLabel,
                perYear,
                perMonth,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].cardLabel == templateData[i].cardLabel &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { cardLabel: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart4Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },            
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0404");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Channel
  openWidget43() {
  
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0404");

    const payLoad = {qry: 'openWidget43', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((sourceType, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                sourceType,
                perYear,
                perMonth,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart4Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0404");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Mode
  openWidget44() {
  
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0404");
    
    const payLoad = {qry: 'openWidget44', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'posEntryMode');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((posEntryMode, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                posEntryMode,
                perYear,
                perMonth,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].posEntryMode == templateData[i].posEntryMode &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { posEntryMode: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart4Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            //colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
        }
        this.ngxService.stopBackgroundLoader("loader-0404");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  openWidget45() {
  
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0404");

    const payLoad = {qry: 'openWidget45', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'processor');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((processor, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                processor,
                perYear,
                perMonth,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].processor == templateData[i].processor &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { processor: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        
        if (series.length > 0) {
          this.apexChart4Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
            },
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              enabledOnSeries: undefined,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              },
            },
            xaxis: {
              type: "category",
              categories: categories,
              tickPlacement: 'on',
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
              formatter: function(data, opts) {
                return data+' - '+thisClass.iposProcessor[data];
              }
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0404");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openModalWidget5(content,loaderId?:string) {
    this.isLoading = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);

    const payLoad = {qry: 'openModalWidget5', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item, index) => {
          data.push(item.totalCount);
          categories.push(`Week ${index + 1}`);
        });
        series = [
          {
            name: "Count",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart5Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                }
              }
            },
            dataLabels: {
              enabled: true,
              formatter: function (data, opts) {
                return thisClass.numbering(data.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              offsetY: -20,
            },
            colors: [
              "#81d77999",
              "#9c1aff99",
              "#c2e68499",
              "#9c1aff4d",
              "#D10CE8",
              "#008FFB",
              "#00E396",
              "#FEB019",
              "#FF4560",
              "#775DD0",
              "#546E7A",
              "#26a69a",
              "#D10CE8"
            ],
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget5 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }        
        this.ngxService.stopBackgroundLoader(loaderId);
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openWidget50(loaderId?:string) {
    this.openModalWidget5(null,loaderId);
  }

  // Device Type
  openWidget51() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0505");
    
    const payLoad = {qry: 'openWidget51', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perWeek,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart5Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
               
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0505");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Card Type
  openWidget52() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0505");
    
    const payLoad = {qry: 'openWidget52', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'cardLabel');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((cardLabel, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                cardLabel,
                perMonth,
                perWeek,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].cardLabel == templateData[i].cardLabel &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { cardLabel: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart5Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0505");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Channel
  openWidget53() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0505");

    const payLoad = {qry: 'openWidget53', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData =  get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((sourceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                sourceType,
                perMonth,
                perWeek,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart5Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0505");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Mode
  openWidget54() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0505");

    const payLoad = {qry: 'openWidget54', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData =  get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'posEntryMode');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((posEntryMode, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                posEntryMode,
                perMonth,
                perWeek,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].posEntryMode == templateData[i].posEntryMode &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { posEntryMode: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart5Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0505");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  openWidget55() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0505");

    const payLoad = {qry: 'openWidget55', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData =  get(res, 'data', []);
        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'processor');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((processor, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                processor,
                perMonth,
                perWeek,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].processor == templateData[i].processor &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { processor: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        
        if (series.length > 0) {
          this.apexChart5Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              toolbar: {
                show: false,
              },
            },
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,              
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              inverseOrder: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
              formatter: function(data, opts) {
                return data+' - '+thisClass.iposProcessor[data];
              }
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0505");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openModalWidget6(content,loaderId?:string) {
    this.isLoading = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);
    
    const payLoad = {qry: 'openModalWidget6', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData = sortBy(rawData,['perDay']);

        rawData.forEach((item) => {
          data.push(item.totalCount);
          categories.push(`${item.perDay}`);
        });
        series = [
          {
            name: "Count",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart6Options = {
            series: series,
            chart: {
              type: "line",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: true,
              }
            },colors: ['#9a17ff'],
            dataLabels: {
              enabled: true,
              formatter: function (data, opts) {
                return thisClass.numbering(data.toString());
              },
              style: {
                colors: ['#000000'],
              }
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US')
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
        }
        if (content) {
          this.modalService
            .open(content, { centered: true, size: "lg" })
            .result.then((result) => {
              this.modalWidget6 = "Modal closed" + result;
            })
            .catch((res) => { });
        }
        this.ngxService.stopBackgroundLoader(loaderId);
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openWidget60(loaderId?:string) {
    this.openModalWidget6(null,loaderId);
  }

  // Device Type
  openWidget61(time_unit?: any,loader?:string) {
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit||'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit||'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader||"loader-0606");

    //const query = `SELECT portal_device_models.identifier as deviceType, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'DAY', '${this.localTZ}') as perDay, COUNT(tx_base.id) as totalCount FROM portal_tx_bases tx_base INNER JOIN portal_tpns ON portal_tpns.tpn=tx_base.tpn INNER JOIN portal_device_models ON portal_device_models.id=portal_tpns.deviceModelId WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3,4 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget61', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perDay,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${time_unit?'Today':perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          const config:any ={
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared:true,
              intersect:false,              
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          if (time_unit == 'day') {
            this.apexChartOptions = config;
          } else {

            this.apexChart6Options = config;
          }
        }
        this.ngxService.stopBackgroundLoader(loader || "loader-0606");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Card Type
  openWidget62(time_unit?: any,loader?:string) {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit|| 'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit|| 'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader||"loader-0606");

    //const query = `SELECT UPPER(cardLabel) as cardLabel, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'DAY', '${this.localTZ}') as perDay, COUNT(tx_base.id) as totalCount FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and cardLabel IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY UPPER(cardLabel),2,3,4 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget62', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'cardLabel');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((cardLabel, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                cardLabel,
                perMonth,
                perDay,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].cardLabel == templateData[i].cardLabel &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${time_unit?'Today':perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { cardLabel: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          const config: any = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#2A2728",
            //   "#FFFF00",              
            //   "#775DD0",
            //   "#546E7A",
            //   "#A52A2A",
            //   "#26a69a",
            //   "#D10CE8",
            //   "#808000",
            //   "#ADD8E6",
            //   "#800080",
            //   "#FF0000",
            //   "#800000",
            //   "#FFC0CB",
            //   "#00FF00",
            //   "#00008B",
            //   "#00FFFF",
            //   "#FF4560",
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          if (time_unit == 'day') {
            this.apexChartOptions = config;
          } else {
            this.apexChart6Options = config;
          }
        }
        this.ngxService.stopBackgroundLoader(loader||"loader-0606");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Channel
  openWidget63(time_unit?: any,loader?:string) {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit || 'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit || 'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader||"loader-0606");

    //const query = `SELECT sourceType, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'DAY', '${this.localTZ}') as perDay, COUNT(tx_base.id) as totalCount FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and sourceType IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3,4 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget63', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((sourceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                sourceType,
                perMonth,
                perDay,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${time_unit?'Today':perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          const config: any = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared:true,
              intersect:false,
              style: {
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          if (time_unit == 'day') {
            this.apexChartOptions = config;
          } else {
            this.apexChart6Options = config;
          }
        }
        this.ngxService.stopBackgroundLoader(loader||"loader-0606");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Mode
  openWidget64(time_unit?: any,loader?:string) {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit || 'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit || 'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader||"loader-0606");

    //const query = `SELECT DISTINCT portal_pos_entry_modes.description as posEntryMode, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'DAY', '${this.localTZ}') as perDay, COUNT(tx_base.id) as totalCount FROM portal_tx_bases tx_base INNER JOIN portal_pos_entry_modes ON portal_pos_entry_modes.code=tx_base.posEntryMode WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and tx_base.posEntryMode IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3,4 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget64', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'posEntryMode');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((posEntryMode, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                posEntryMode,
                perMonth,
                perDay,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].posEntryMode == templateData[i].posEntryMode &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${time_unit?'Today':perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { posEntryMode: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          const config :any ={
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared:true,
              intersect:false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
            },
            fill: {
              opacity: 1
            }
          };
          if(time_unit == 'day') {
            this.apexChartOptions = config;
          } else {
            this.apexChart6Options = config;
          }
        }
        this.ngxService.stopBackgroundLoader(loader||"loader-0606");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  openWidget65(time_unit?: any,loader?:string) {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit || 'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit || 'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader||"loader-0606");

    //const query = `SELECT UPPER(tx_base.destType) as processor , TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'DAY', '${this.localTZ}') as perDay, COUNT(tx_base.id) as totalVolume FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY UPPER(tx_base.destType),2,3,4 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget65', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'processor');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((processor, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                processor,
                perMonth,
                perDay,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].processor == templateData[i].processor &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${time_unit?'Today':perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { processor: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        
        if (series.length > 0) {
          const config :any ={
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              toolbar: {
                show: false,
              }
            },
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
              formatter: function(data, opts) {
                return data+' - '+thisClass.iposProcessor[data];
              }
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

          if(time_unit == 'day') {
            this.apexChartOptions = config;
          } else {
            this.apexChart6Options = config;
          }
        }
        this.ngxService.stopBackgroundLoader(loader||"loader-0606");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openModalWidget7(content,loaderId?:string) {
    this.isLoading = true;
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);

    //const query = `SELECT TIME_EXTRACT(__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(__time, 'MONTH', '${this.localTZ}') as perMonth, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases WHERE ${this.qryWhereTPN} TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2 ORDER BY 1 ASC`;
    //tpnsList: this.tpns ? this.tpns : '',
    const payLoad = {qry: 'openModalWidget7', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item) => {
          data.push(item.totalVolume);
          categories.push(`${thisClass.getMonth(item.perMonth, item.perYear)}`);
        });
        series = [
          {
            name: "Volume",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart7Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              "#81d77999",
              "#9c1aff99",
              "#c2e68499",
              "#9c1aff4d",
              "#D10CE8",
              "#008FFB",
              "#00E396",
              "#FEB019",
              "#FF4560",
              "#775DD0",
              "#546E7A",
              "#26a69a",
              "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "40%",
                distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.currency(val.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              offsetY: -20,
              //distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return '$' + data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget7 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
        this.ngxService.stopBackgroundLoader(loaderId);
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }
  customerSummaryThisMonth(content, loaderId?: string,dtRange='') {
    this.isLoading = true;
    this.modalTitle = this.thismonth;
    this.period = 'thismonth';
    this.apexChartSPCustomers = this.apexChartSPCustomer2
    this.customersCount = this.thisMonthCustomersCount;
    this.isChartShow = true;
    this.isStateShow = false;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);
   

    //const query = `SELECT TIME_EXTRACT(__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(__time, 'DAY', '${this.localTZ}') as perDay, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases WHERE ${this.qryWhereTPN} TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3 ORDER BY 1 ASC`;
    //tpnsList: this.tpns ? this.tpns : '',
    const payLoad = { qry: 'customerSummaryThisMonth', localTZ: this.localTZ, fromDate, endOfMonth };
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {   
        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData = sortBy(rawData, ['perDay']);

        rawData.forEach((item, index) => {
          data.push(item.totalCount);
          categories.push(`${item.perDay}`);
        });
        series = [
          {
            name: "Count",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChartSPCustomers = {
            series: series,
            chart: {
              type: "line",
              height: '480',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: true,
              }
            },
            colors:['#9c1aff99'],
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.numbering(val.toString());
              },
              textAnchor: 'middle',
              distributed: true,
              style: {
                colors: ['#000000'],
              }
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
         
        }
        if (content) {
          this.modalService
            .open(content, { centered: true, size: "xl",keyboard: false,backdrop: 'static' })
            .result.then((result) => {
              this.modalWidgetSPCustomer2 = "Modal closed" + result;
            })
            .catch((res) => { });
        }
        this.isLoading = false;
      },
      (err) => {
        //   this.showAlert(err, "error");

      }
    );
  
    this.ngxService.stopBackgroundLoader(loaderId);

  }
  customerSummaryLastMonth(content, loaderId?: string,dtRange='') {
    this.modalTitle = this.lastmonth;
    this.period = 'lastmonth';
    this.customersCount = this.lastMonthCustomersCount;
    this.apexChartSPCustomers = this.apexChartSPCustomer3;
    this.isLoading = true;
    this.isChartShow = true;
    this.isStateShow = false;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);

    //const query = `SELECT TIME_EXTRACT(__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(__time, 'WEEK', '${this.localTZ}') as "perWeek", ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases WHERE ${this.qryWhereTPN} TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3 ORDER BY 1 ASC`;
    
    const payLoad = { qry: 'customerSummaryLastMonth', localTZ: this.localTZ, fromDate, endOfMonth};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item, index) => {
          data.push(item.totalCount);
          categories.push(`${item.perDay}`);
        });
        series = [
          {
            name: "Count",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChartSPCustomers = {
            series: series,
            chart: {
              type: "line",
              height: '480',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors:['#9c1aff99'],
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              },
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.numbering(val.toString());
              },
              textAnchor: 'middle',
              distributed: true,
              style: {
                fontSize: '12px',
                colors:["#000000"]
              },
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return  data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };      
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "xl",keyboard: false,backdrop: 'static' })
              .result.then((result) => {
                this.modalWidgetSPCustomer2 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        } 
        this.isLoading = false;
      },
      (err) => {
        //   this.showAlert(err, "error");
      }
    );
    this.ngxService.stopBackgroundLoader(loaderId);
   
  }
  customerSummaryTotal(content, loaderId?: string,dtRange='') {
    this.modalTitle = this.overall;
    this.period = 'overall';
    this.customersCount = this.overallCustomersCount;
    this.apexChartSPCustomers = this.apexChartSPCustomer;
    this.isLoading = true;
    this.isChartShow = true;
    this.isStateShow = false;
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);
    const payLoad = { qry: 'customerSummaryTotal', localTZ: this.localTZ, fromDate, endOfMonth };
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item) => {
          data.push(item.totalCount);
          categories.push(`${thisClass.getMonth(item.perMonth, item.perYear)}`);
        });
        series = [
          {
            name: "Count",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChartSPCustomers = {
            series: series,
            chart: {
              type: "bar",
              height: '480',
              width: '100%',
              //stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              '#9c1aff99',
              '#c2e68499',
              '#9c1aff4d',
              '#c2e68499'
              // "#008FFB",
              // "#00E396",
              // "#FEB019",
              // "#FF4560",
              // "#775DD0",
              // "#546E7A",
              // "#26a69a",
              // "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.numbering(val.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#000000"]
              },
              textAnchor: 'middle',
              offsetY: -20,
              //distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "xl",keyboard: false,backdrop: 'static' })
              .result.then((result) => {
                this.modalWidgetSPCustomer2 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
        this.isLoading = false;
      },
      (err) => {
          //this.showAlert(err, "error");      
      }
    );
    this.ngxService.stopBackgroundLoader(loaderId);
  }


  // Summary
  openWidget70(loaderId?:string) {
    this.openModalWidget7(null,loaderId);
  }

  // Device Type
  openWidget71() {
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0707");

    //const query = `SELECT portal_device_models.identifier as deviceType, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base INNER JOIN portal_tpns ON portal_tpns.tpn=tx_base.tpn INNER JOIN portal_device_models ON portal_device_models.id=portal_tpns.deviceModelId WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget71', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((deviceType, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                deviceType,
                perYear,
                perMonth,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart7Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "40%",
                // distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.currency(val.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              //offsetY: -20,
              //distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              enabledOnSeries: undefined,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              },
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
              onItemClick: {
                toggleDataSeries: true
              },
              onItemHover: {
                highlightDataSeries: true
              },
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0707");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Card Type
  openWidget72() {
  
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0707");

    //const query = `SELECT UPPER(cardLabel) as cardLabel, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and cardLabel IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY UPPER(cardLabel),2,3 ORDER BY 1,2 ASC`;
    //tpnsList: this.tpns ? this.tpns : '',
    const payLoad = {qry: 'openWidget72', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'cardLabel');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((cardLabel, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                cardLabel,
                perYear,
                perMonth,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].cardLabel == templateData[i].cardLabel &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { cardLabel: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart7Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              enabledOnSeries: undefined,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              },
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  //  colors: [

                  //   ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0707");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Channel
  openWidget73() {
  
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0707");

    //const query = `SELECT sourceType, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and sourceType IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget73', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((sourceType, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                sourceType,
                perYear,
                perMonth,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart7Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              enabledOnSeries: undefined,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              },
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0707");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Mode
  openWidget74() {
  
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0707");

    //const query = `SELECT DISTINCT portal_pos_entry_modes.description as posEntryMode, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base INNER JOIN portal_pos_entry_modes ON portal_pos_entry_modes.code=tx_base.posEntryMode WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and tx_base.posEntryMode IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3 ORDER BY 1,2 ASC`;
    //tpnsList: this.tpns ? this.tpns : '',
    const payLoad = {qry: 'openWidget74', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'posEntryMode');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((posEntryMode, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                posEntryMode,
                perYear,
                perMonth,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].posEntryMode == templateData[i].posEntryMode &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { posEntryMode: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart7Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                autoSelected: 'zoom',
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
            },            
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              enabledOnSeries: undefined,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              },
            },
            xaxis: {
              type: "category",
              categories: categories,
              tickPlacement: 'on',
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },            
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0707");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  openWidget75() {
  
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0707");

    //const query = `SELECT UPPER(tx_base.destType) as processor, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY UPPER(tx_base.destType),2,3 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget75', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = orderBy(rawData,['perMonth'],['asc']);

        gropingDataType = lodashMap(rawData, 'processor');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((processor, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                processor,
                perYear,
                perMonth,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].processor == templateData[i].processor &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);
        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);
        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { processor: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        
        if (series.length > 0) {
          this.apexChart7Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
            },
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              enabledOnSeries: undefined,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              },
            },
            xaxis: {
              type: "category",
              categories: categories,
              tickPlacement: 'on',
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
              formatter: function(data, opts) {
                return data+' - '+thisClass.iposProcessor[data];
              }
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0707");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }
  //Summary for Customer
  openWidgetSPCustomer3(loaderId?:string,dtRange=''){
   
    this.apexChartSPCustomer.series=[];
    this.customerSummaryTotal(null,loaderId,dtRange);
  }
  openWidgetSPCustomer4(loaderId?:string,dtRange=''){
    if(this.period == 'lastmonth'){
      this.openWidgetSPCustomer5(loaderId, dtRange);
      return
    } else if (this.period == 'overall') {
      this.openWidgetSPCustomer3(loaderId, dtRange);
      return
    }
    
    this.apexChartSPCustomer2.series =[];         
    this.customerSummaryThisMonth(null,loaderId,dtRange);
  }
  openWidgetSPCustomer5(loaderId?:string,dtRange=''){
    this.apexChartSPCustomer3.series=[];
    this.customerSummaryLastMonth(null,loaderId,dtRange);
  }

  // Summary
  openModalWidget8(content,loaderId?:string) {
    this.isLoading = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);

    //const query = `SELECT TIME_EXTRACT(__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(__time, 'WEEK', '${this.localTZ}') as "perWeek", ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases WHERE ${this.qryWhereTPN} TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3 ORDER BY 1 ASC`;
    
    const payLoad = {qry: 'openModalWidget8', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item, index) => {
          data.push(item.totalVolume);
          categories.push(`Week ${index + 1}`);
        });
        series = [
          {
            name: "Volume",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart8Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              "#81d77999",
              "#9c1aff99",
              "#c2e68499",
              "#9c1aff4d",
              "#D10CE8",
              "#008FFB",
              "#00E396",
              "#FEB019",
              "#FF4560",
              "#775DD0",
              "#546E7A",
              "#26a69a",
              "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              },
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.currency(val.toString());
              },
              textAnchor: 'middle',
              distributed: true,
              offsetY: -20,
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return '$' + data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader(loaderId);
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget8 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
        this.isLoading =false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openWidget80(loaderId?:string) {
    this.openModalWidget8(null,loaderId);
  }

  // Device Type
  openWidget81() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0808");

    //const query = `SELECT portal_device_models.identifier as deviceType, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'WEEK', '${this.localTZ}') as perWeek, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base INNER JOIN portal_tpns ON portal_tpns.tpn=tx_base.tpn INNER JOIN portal_device_models ON portal_device_models.id=portal_tpns.deviceModelId WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3,4 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget81', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perWeek,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart8Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0808");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Card Type
  openWidget82() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0808");

    //const query = `SELECT UPPER(cardLabel) as cardLabel, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'WEEK', '${this.localTZ}') as perWeek, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and cardLabel IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY UPPER(cardLabel),2,3,4 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget82', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'cardLabel');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((cardLabel, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                cardLabel,
                perMonth,
                perWeek,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].cardLabel == templateData[i].cardLabel &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { cardLabel: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart8Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0808");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Channel
  openWidget83() {
  
    const thisClass = this;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader("loader-0808");

    //const query = `SELECT sourceType, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'WEEK', '${this.localTZ}') as perWeek, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and sourceType IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3,4 ORDER BY 1,2 ASC`;
    //tpnsList: this.tpns ? this.tpns : '',
    const payLoad = {qry: 'openWidget83', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((sourceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                sourceType,
                perMonth,
                perWeek,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart8Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0808");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Mode
  openWidget84() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0808");

    //const query = `SELECT DISTINCT portal_pos_entry_modes.description as posEntryMode, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'WEEK', '${this.localTZ}') as perWeek, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base INNER JOIN portal_pos_entry_modes ON portal_pos_entry_modes.code=tx_base.posEntryMode WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and tx_base.posEntryMode IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3,4 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget84', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'posEntryMode');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((posEntryMode, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                posEntryMode,
                perMonth,
                perWeek,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].posEntryMode == templateData[i].posEntryMode &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { posEntryMode: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          this.apexChart8Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,              
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              inverseOrder: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0808");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  openWidget85() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-0808");
    const payLoad = {qry: 'openWidget85', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'processor');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((processor, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                processor,
                perMonth,
                perWeek,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].processor == templateData[i].processor &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { processor: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        
        if (series.length > 0) {
          this.apexChart8Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              toolbar: {
                show: false,
              },
            },
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,              
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              inverseOrder: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
              formatter: function(data, opts) {
                return data+' - '+thisClass.iposProcessor[data];
              }
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader("loader-0808");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  trendChart = async (template, type, resData) => {
    try {  
      let rawData = get(resData, 'data', []);
      let dataMap = new Map();
      let data = [];
      let categories = [];
  
      rawData = sortBy(rawData, ['perHour']);
  
      rawData.forEach(item => {
        dataMap.set(item.perHour, item.total);
      });
  
      for (let index = 0; index <= 23; index++) {
        categories.push(`${index}`);
        data.push(dataMap.get(index) ?? 0); 
      }
  
      if (!data.length) {
        return this.showAlert('No Data', "error");
      }
  
      let series = [
        {
          name: `${type}`,
          data
        }
      ];
      if (data?.length > 0) {
        this.lineChartConfig.series = series;
        this.lineChartConfig.xaxis.categories = categories;
        this.lineChartConfig.xaxis.min = 0;
        this.lineChartConfig.xaxis.max = 24;
        this.apexChartOptions = this.lineChartConfig;
      }
      
      if (template && resData.data.length > 0) {
        this.modalService
          .open(template, { centered: true, size: "lg" })
          .result.then((result) => {
            // this.modalWidget9 = "Modal closed" + result;
          })
          .catch((res) => { });
      }
      this.isLoading = false;
    } catch (error) {
      throw error;  
    }
  }

  async openWidget(template: TemplateRef<any>, chart_type: string, time_unit: string, type: string) {
    try {
      this.ngxService.startBackgroundLoader(`${template ? time_unit : time_unit+'-'+type}`);
      this.isLoading = true;
      let nowUTC = moment().utc();
      let fromDate: any = new Date();
      let toDate: any = new Date();
      this.title = `Processing ${type?.includes("volume") ? 'Volume' : 'Count'} - Today`;
      switch (time_unit) {
        case "today":
          fromDate = nowUTC.tz(this.localTZ).startOf('day').format(this.dateFormat);
          toDate = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
          default:
            break;
      }

      const payLoad = { qry: chart_type, type, localTZ: this.localTZ, fromDate, toDate, listIsoHierarchyStr: this.listIsoHierarchyStr ? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : '' };
          const resData = await this.DashboardService.getNewDashboardDataInfo(payLoad).toPromise();
      if (chart_type == 'trend') {
        await this.trendChart(template, type, resData);
      }

      this.ngxService.stopBackgroundLoader(`${template ? time_unit : time_unit+'-'+type}`);
      this.isLoading = false;
      
    } catch (error) {
      this.ngxService.stopBackgroundLoader(`${template ? time_unit : time_unit+'-'+type}`);
    }

  }

  // Summary
  openModalWidget9(content,loaderId?:string) {
    this.isLoading = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);

    const payLoad = {qry: 'openModalWidget9', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData = sortBy(rawData,['perDay']);

        rawData.forEach((item, index) => {
          data.push(item.totalVolume);
          categories.push(`${item.perDay}`);
        });
        series = [
          {
            name: "Volume",
            data
          }
        ];
        if (data.length > 0) {          
          this.apexChart9Options = {
            series: series,
            chart: {
              type: "line",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: true,
              }
            },
            colors: ['#9a17ff'],
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.currency(val.toString());
              },
              textAnchor: 'middle',
              distributed: true,
              style: {
                colors: ['#000000'],
              }
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return '$' + data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader(loaderId);
        }
        if (content) {
          this.modalService
            .open(content, { centered: true, size: "lg" })
            .result.then((result) => {
              this.modalWidget9 = "Modal closed" + result;              
            })
            .catch((res) => { });
        }
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openWidget90(loaderId?:string) {
    this.openModalWidget9(null,loaderId);
  }

  // Device Type
  openWidget91(time_unit?: any,loader?:string) {
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit || 'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit || 'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader || "loader-0909");
    const payLoad = {qry: 'openWidget91', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        
        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perDay,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${time_unit?'Today':perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          const config: any = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared:true,
              intersect:false,
              style: {
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          if (time_unit == 'day') {
            this.apexChartOptions = config;
          } else {
            this.apexChart9Options = config;
          }

          this.ngxService.stopBackgroundLoader( loader || "loader-0909");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Card Type
  openWidget92(time_unit?: any,loader?:string) {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit || 'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit || 'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader || "loader-0909");

    //const query = `SELECT UPPER(cardLabel) as cardLabel, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'DAY', '${this.localTZ}') as perDay, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and cardLabel IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY UPPER(cardLabel),2,3,4 ORDER BY 1,2 ASC`;
    //tpnsList: this.tpns ? this.tpns : '',
    const payLoad = {qry: 'openWidget92', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'cardLabel');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((cardLabel, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                cardLabel,
                perMonth,
                perDay,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].cardLabel == templateData[i].cardLabel &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${time_unit ? 'Today': perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { cardLabel: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {

          const config:any = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          if(time_unit == 'day') {
            this.apexChartOptions = config;
          } else {
            this.apexChart9Options = config;
          }
          this.ngxService.stopBackgroundLoader(loader || "loader-0909");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Channel
  openWidget93(time_unit?: any,loader?:string) {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit || 'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit || 'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader || "loader-0909");

    //const query = `SELECT sourceType, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'DAY', '${this.localTZ}') as perDay, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and sourceType IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3,4 ORDER BY 1,2 ASC`;
    
    const payLoad = {qry: 'openWidget93', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData =  get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((sourceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                sourceType,
                perMonth,
                perDay,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${time_unit?'Today':perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          const config :any ={
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared:true,
              intersect:false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

          if (time_unit == 'day') {
            this.apexChartOptions = config;
          } else {
            this.apexChart9Options = config;

          }
          this.ngxService.stopBackgroundLoader(loader || "loader-0909");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Mode
  openWidget94(time_unit?: any,loader?:string) {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit || 'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit || 'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader || "loader-0909");

    //const query = `SELECT DISTINCT portal_pos_entry_modes.description as posEntryMode, TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'DAY', '${this.localTZ}') as perDay, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base INNER JOIN portal_pos_entry_modes ON portal_pos_entry_modes.code=tx_base.posEntryMode WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' and tx_base.posEntryMode IS NOT NULL AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY 1,2,3,4 ORDER BY 1,2 ASC`;
    //tpnsList: this.tpns ? this.tpns : '',
    const payLoad = {qry: 'openWidget94', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'posEntryMode');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((posEntryMode, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                posEntryMode,
                perMonth,
                perDay,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].posEntryMode == templateData[i].posEntryMode &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { posEntryMode: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        

        if (series.length > 0) {
          const config :any = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            colors: [
              '#c2e68499',
              '#9c1aff99',
              '#9c1aff4d',
              '#c2e68499',
              "#008FFB",
              "#00E396",
              "#FEB019",
              "#FF4560",
              "#775DD0",
              "#546E7A",
              "#26a69a",
              "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared:true,
              intersect:false,
              style: {
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
            },
            fill: {
              opacity: 1
            }
          };
          if (time_unit == 'day') {
            this.apexChartOptions = config;
          } else {
            this.apexChart9Options = config;
          }
          this.ngxService.stopBackgroundLoader(loader ||"loader-0909");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  openWidget95(time_unit?: any,loader?:string) {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf(time_unit || 'month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf(time_unit || 'month').format(this.dateFormat);
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loader || "loader-0909");

    //const query = `SELECT UPPER(tx_base.destType) as processor , TIME_EXTRACT(tx_base.__time, 'YEAR', '${this.localTZ}') as perYear, TIME_EXTRACT(tx_base.__time, 'MONTH', '${this.localTZ}') as perMonth, TIME_EXTRACT(tx_base.__time, 'DAY', '${this.localTZ}') as perDay, ROUND(SUM(totalAmount), 0) as totalVolume FROM portal_tx_bases tx_base WHERE ${this.qryWhereTxBaseTPN} TIME_FORMAT(tx_base.__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' AND tx_base.posResponseCode IN (${this.posResponseCode}) GROUP BY UPPER(tx_base.destType),2,3,4 ORDER BY 1,2 ASC`;
    //tpnsList: this.tpns ? this.tpns : '',
    const payLoad = {qry: 'openWidget95', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'processor');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((processor, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                processor,
                perMonth,
                perDay,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].processor == templateData[i].processor &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalVolume = rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${time_unit?'Today':perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { processor: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        
        if (series.length > 0) {
          const config: any = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              toolbar: {
                show: false,
              }
            },
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                // return w.config.series[seriesIndex].name;
                return "";
              },
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: "top",
              offsetY: 0,
              formatter: function (data, opts) {
                return data + ' - ' + thisClass.iposProcessor[data];
              }
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          if (time_unit == 'day') {
            this.apexChartOptions = config;
          } else {
            this.apexChart9Options = config;
          }
          this.ngxService.stopBackgroundLoader(loader || "loader-0909");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // //////////////////////////////////

  // Summary
  openModalWidget10(content,loaderId?:string) {
    this.isLoading = true;
    this.isChartShow = true;
    let qryWhereOwnedByCustomer ='';
    let qryWhereOwnedBy = '';
    const thisClass = this;
    this.ngxService.startBackgroundLoader(loaderId);
    if (!isEmpty(this.selectedISO)) {
      qryWhereOwnedByCustomer = " ownedByCustomer IN ("+this.listIsoHierarchyStr+") AND ";
      qryWhereOwnedBy = " ownedBy IN ("+this.listIsoHierarchyStr+") AND ";
    } 

    const payLoad = {qry: 'openModalWidget10_Merchant', localTZ: this.localTZ, customerIds: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : ''};
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      async (res) => {
        let rawData = get(res, 'data', []);
        let data = [];
        let tpnData = [];
        let series = [];
        let categories = [];

      
        const payLoad = {qry: 'openModalWidget10_TPN', localTZ: this.localTZ, ownedByCustomerIds: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : ''};
        await this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
        async (res) => {
            let tpnRawData = get(res, 'data', []);     
          const emptyArrayOject = (day, week, month) =>  ({
            "perYear": 0,
            "perMonth": month,
            "perDay": day,
            "perWeek": week,
            "totalCount": 0
          })
          const modifiedTpnArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(0,0,i+1))
          const modifiedMerchantArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(0,0,i+1))
        
          for ( let i = 0 ; i < rawData.length ; i ++) {
            const perMonth = rawData[i].perMonth
            modifiedMerchantArray[perMonth-1] = rawData[i]
          }
          for (let i = 0; i < tpnRawData.length; i++) {
            const perMonth = tpnRawData[i].perMonth
            modifiedTpnArray[perMonth - 1] = tpnRawData[i]
          }

          const graphTpnArray = [...modifiedTpnArray]
          const graphMerchantArray = [...modifiedMerchantArray]
          let  modifiedIndex = -1
          for ( let i = 0 ; i < 31 ; i ++) {
              if( modifiedMerchantArray[i].totalCount == 0 && modifiedTpnArray[i].totalCount == 0) {
                modifiedIndex ++
                graphTpnArray.splice(i - modifiedIndex, 1);
                graphMerchantArray.splice(i - modifiedIndex, 1);
              }
          }

          let graphMerchantSortedArray = sortBy(graphMerchantArray, ['perYear','perMonth'])
          let graphTpnSortedArray = sortBy(graphTpnArray, ['perYear','perMonth'])
          let merCategories = [];
          graphMerchantSortedArray.forEach((item,index) => {
            data.push(item.totalCount);
            merCategories.push(`${thisClass.getMonth(item.perMonth, item.perYear)}`);
          });

          graphTpnSortedArray.forEach((item) => {
            tpnData.push(item.totalCount);
            categories.push(`${thisClass.getMonth(item.perMonth, item.perYear)}`);
          });                

          series = [
            {
              name: "Merchant",
              data
            },
            {
              name: "TPN",
              data: tpnData,
            }
          ];

          if (data.length > 0) {
            this.apexChart10Options = {
              series: series,
              chart: {
                type: "bar",
                height: 'auto',
                width: '100%',
                stacked: false,
                events: {
                  click: function (chart, w, e) {

                  }
                },
                toolbar: {
                  show: false,
                },
                zoom: {
                  enabled: true
                }
              },
              responsive: [
                {
                  breakpoint: 10,
                  options: {
                  }
                }
              ],
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "40%",
                  distributed: false,
                  dataLabels: {
                    position: 'top', // top, center, bottom
                  }
                }
              },
              dataLabels: {
                enabled: true,
                enabledOnSeries: undefined,
                formatter: function (val, opts) {
                  return thisClass.numbering(val.toString());
                },
                style: {
                  fontSize: '12px',
                  colors: ["#304758"]
                },
                textAnchor: 'middle',
                offsetY: -20,
                //distributed: true,
              },
              colors:['#9c1aff99','#81d77999'],
              grid: {
                show: true,
              },
              tooltip: {
                enabled: true,
                shared: true,
                intersect: false,
                style: {  
                  fontSize: '12px'
                },
                y: {
                  formatter: function (data, opts) {
                    return data.toLocaleString('en-US');
                  }
                }
              },
              xaxis: {
                type: "category",
                categories: categories,
                labels: {
                  style: {
                    fontSize: "12px"
                  }
                },
              },
              legend: {
                show: true,
                position: "top",
              },
              fill: {
                opacity: 1
              }
            };
            if (content) {
              this.modalService
                .open(content, { centered: true, size: "lg" })
                .result.then((result) => {
                  this.modalWidget10 = "Modal closed" + result;
                })
                .catch((res) => { });
            }
            
          }
          this.isLoading = false;
        }
        )
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
    this.ngxService.stopBackgroundLoader(loaderId);
  }

  // Summary
  openWidget100(loaderId?:string) {
    this.openModalWidget10(null,loaderId);
  }

  // Summary
  openModalWidget11(content,loaderId?:string) {
    this.isLoading = true;
    this.isChartShow = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let startWeek = moment(fromDate).week();
    let endWeek = moment(endOfMonth).week();
    this.ngxService.startBackgroundLoader(loaderId);

    let qryWhereOwnedByCustomer ='';
    let qryWhereOwnedBy = '';
    if (!isEmpty(this.selectedISO)) {
      qryWhereOwnedByCustomer = " ownedByCustomer IN ("+this.listIsoHierarchyStr+") AND ";
      qryWhereOwnedBy = " ownedBy IN ("+this.listIsoHierarchyStr+") AND ";
    } 

    const payLoad = {qry: 'openModalWidget11_Merchant', localTZ: this.localTZ, customerIds: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '', fromDate, endOfMonth}
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      async (res) => {
    
        let resData = get(res, 'data', []);
        let rawData = resData;
        let data = [];
        let tpnData = [];
        let series = [];
        let categories = [];

        const thisClass = this;
        const payLoad = {qry: 'openModalWidget11_TPN', localTZ: this.localTZ, ownedByCustomerIds: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '', fromDate, endOfMonth}
        let tpnRawData =  [];
        await this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
          (res) => {

          tpnRawData = get(res, 'data', []);           

        const emptyArrayOject = (day) =>  ({
          "perYear": 0,
          "perMonth": 0,
          "perDay": day,
          //"perWeek": 0,
          "totalCount": 0
        })

        const modifiedTpnArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(i+1))
        const modifiedMerchantArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(i+1))
     
        for ( let i = 0 ; i < rawData.length ; i ++) {
          const perDay = rawData[i].perDay
          modifiedMerchantArray[perDay-1] = rawData[i]
        }
        for (let i = 0; i < tpnRawData.length; i++) {
          const perDay = tpnRawData[i].perDay
          modifiedTpnArray[perDay - 1] = tpnRawData[i]
        }

        const graphTpnArray = [...modifiedTpnArray]
        const graphMerchantArray = [...modifiedMerchantArray]
        let  modifiedIndex = -1
        for ( let i = 0 ; i < 31 ; i ++) {
            if( modifiedMerchantArray[i].totalCount == 0 && modifiedTpnArray[i].totalCount == 0) {
              modifiedIndex ++
              graphTpnArray.splice(i - modifiedIndex, 1);
              graphMerchantArray.splice(i - modifiedIndex, 1);
            }
        }

       
        graphMerchantArray.forEach((item,index) => {
          data.push(item.totalCount);
      
          categories.push(`${item.perDay}`)
        });
        graphTpnArray.forEach((item) => {
          tpnData.push(item.totalCount);
         
        });

        series = [
          {
            name: "Merchant",
            data
          },
          {
            name: "TPN",
            data: tpnData,
          }
        ];
        if (data.length > 0) {
          this.apexChart11Options = {
            series: series,
            chart: {
              type: "line",
              height: 'auto',
              width: '100%',
              stacked: false,
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            // plotOptions: {
            //   bar: {
            //     horizontal: false,
            //     columnWidth: "40%",
            //     distributed: false,
            //     dataLabels: {
            //       position: 'top', // top, center, bottom
            //     },
            //   }
            // },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.numbering(val.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              //offsetY: -20,
              //distributed: true,
            },
            colors:['#9c1aff99','#81d77999'],
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              title: {
                text: 'Day(s)',                
              },
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              showForSingleSeries: true,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget2 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
          
        }
        this.isLoading = false;
      });
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
    this.ngxService.stopBackgroundLoader(loaderId);
  }

  // Summary
  openWidget110(loaderId?:string) {
    this.openModalWidget11(null,loaderId);
  }

  // Summary
  async openModalWidget12(content,loaderId) {
    this.isLoading = true;
    this.isChartShow = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader(loaderId);

    let qryWhereOwnedByCustomer ='';
    let qryWhereOwnedBy = '';
    if (!isEmpty(this.selectedISO)) {
      qryWhereOwnedByCustomer = " ownedByCustomer IN ("+this.listIsoHierarchyStr+") AND ";
      qryWhereOwnedBy = " ownedBy IN ("+this.listIsoHierarchyStr+") AND ";
    } 

    const thisClass = this;
    const payLoad = {qry: 'openModalWidget12_Merchant', localTZ: this.localTZ, customerIds: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '', fromDate, endOfMonth}
    const qryData = await this.getNewDashboardDataInfo(payLoad);
  
        if(qryData) {
          let rawData = qryData;
          let data = [];
          let tpnData = [];
          let series = [];
          let categories = [];
            const payLoad2 = {qry: 'openModalWidget12_TPN', localTZ: this.localTZ, ownedByCustomerIds: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '', fromDate, endOfMonth}
            const qryData2 = await this.getNewDashboardDataInfo(payLoad2);

         
              let tpnRawData = qryData2;     
            
  
          const emptyArrayOject = (day) =>  ({
            "perYear": 0,
            "perMonth": 0,
            "perDay": day,
            "totalCount": 0
          })
          const modifiedTpnArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(i+1))
          const modifiedMerchantArray = Array.from({ length: 31 }, (_, i) => emptyArrayOject(i+1))
          for ( let i = 0 ; i < rawData.length ; i ++) {
            const perDay = rawData[i].perDay
            modifiedMerchantArray[perDay-1] = rawData[i]
          }
          for (let i = 0; i < tpnRawData.length; i++) {
            const perDay = tpnRawData[i].perDay
            modifiedTpnArray[perDay - 1] = tpnRawData[i]
          }
  
          const graphTpnArray = [...modifiedTpnArray]
          const graphMerchantArray = [...modifiedMerchantArray]
          let  modifiedIndex = -1
          for ( let i = 0 ; i < 31 ; i ++) {
              if( modifiedMerchantArray[i].totalCount == 0 && modifiedTpnArray[i].totalCount == 0) {
                modifiedIndex ++
                graphTpnArray.splice(i - modifiedIndex, 1);
                graphMerchantArray.splice(i - modifiedIndex, 1);
              }
          }
  
          graphMerchantArray.forEach((item) => {
            data.push(item.totalCount);
            categories.push(`${item.perDay}`);
          });
          graphTpnArray.forEach((item) => {
            tpnData.push(item.totalCount);
            //tpnCategories.push(`${item.perDay}`);
          });
  
          series = [
            {
              name: "Merchant",
              data
            },
            {
              name: "TPN",
              data: tpnData,
            }
          ];
  
          if (data.length > 0) {
            this.apexChart12Options = {
              series: series,
              chart: {
                type: "line",
                height: 'auto',
                width: '100%',
                stacked: false,
                events: {
                  click: function (chart, w, e) {
  
                  }
                },
                toolbar: {
                  show: false,
                },
                zoom: {
                  enabled: true
                }
              },
              // colors: [
              //   "#008FFB",
              //   "#00E396",
              //   "#FEB019",
              //   "#FF4560",
              //   "#775DD0",
              //   "#546E7A",
              //   "#26a69a",
              //   "#D10CE8"
              // ],
              responsive: [
                {
                  breakpoint: 10,
                  options: {
                  }
                }
              ],
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "30%",
                  distributed: false,
                  dataLabels: {
                    position: 'top', // top, center, bottom
                  },
                }
              },
              dataLabels: {
                enabled: true,
                enabledOnSeries: undefined,
                formatter: function (val, opts) {
                  return thisClass.numbering(val.toString());
                },
                style: {
                  fontSize: '12px',
                  colors: ["#304758"]
                },
                textAnchor: 'middle',
                //offsetY: -20,
                //distributed: true,
              },
              colors:['#9c1aff99','#81d77999'],
              grid: {
                show: true,
              },
              tooltip: {
                enabled: true,
                shared: true,
                intersect: false,
                style: {  
                  fontSize: '12px'
                },
                y: {
                  formatter: function (data, opts) {
                    return data.toLocaleString('en-US');
                  }
                }
              },
              xaxis: {
                type: "category",
                categories: categories,
                title: {
                  text: 'Day(s)',                
                },
                labels: {
                  style: {
                    // colors: [
                    //   "#008FFB",
                    //   "#00E396",
                    //   "#FEB019",
                    //   "#FF4560",
                    //   "#775DD0",
                    //   "#546E7A",
                    //   "#26a69a",
                    //   "#D10CE8"
                    // ],
                    fontSize: "12px"
                  }
                },
              },
              legend: {
                show: true,
                position: "top",
              },
              fill: {
                opacity: 1
              }
            };
            if (content) {
              this.modalService
                .open(content, { centered: true, size: "lg" })
                .result.then((result) => {
                  this.modalWidget3 = "Modal closed" + result;
                })
                .catch((res) => { });
            }
            
          }
        }
        this.ngxService.stopBackgroundLoader(loaderId);
        this.isLoading = false;
    //   },
    //   (err) => {
    //     // this.showAlert(err, "error");
    //   }
    // );
  }

  // Summary
  openWidget120(loaderId?:string) {
    this.openModalWidget12(null,loaderId);
  }


  getArrayOfDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var endDate = moment(stopDate);
    while (currentDate <= endDate) {
        //dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
        dateArray.push({[moment(currentDate).format('YYYY-MM-DD')]:0})
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }

  // Merchant & TPN Active Count
  async getLast30DaysMerchant() {
    this.ngxService.startBackgroundLoader("loader-defaultMerchant30");
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(29, 'day').startOf('day').format(this.dateFormat);

    // merchantIds: this.merchantIds ? this.merchantIds : '',
    const payLoad = {qry: 'getLast30DaysMerchant', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
    const qryData = await this.getNewDashboardDataInfo(payLoad);
    const thisClass = this;

    if(qryData) {
      let rawData = qryData;
      let data = [];
      let series = [];
      let categories = [];

      rawData = sortBy(rawData,['perYear','perMonth','perDay']);

      rawData.forEach((item, index) => {
        data.push(item.totalCount);
        const dateMoment = moment({
          year: item.perYear,
          month: item.perMonth - 1,
          day: item.perDay
        });

        const graphDate = dateMoment.format('MMM-DD-YYYY');
        categories.push(graphDate);
      });
      series = [
        {
          name: "TPN",
          data
        }
      ];
      if (data.length > 0) {
        this.last30MerchantShow = true;
        this.apexChartDefaultMerchant30 = {
          series: series,
          chart: {
            type: "bar",
            height: 350,
            width: '100%',
            stacked: false,
            events: {
              click: function (chart, w, e) {
              }
            },
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: false
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "20%",
              distributed: false,
              dataLabels: {
                position: 'top', // top, center, bottom
              },
            }
          },
          title: {
            text: 'Last 30 days',
            align: 'center',
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: undefined,
            formatter: function (val, opts) {
              return thisClass.numbering(val.toString());
            },
            style: {
              fontSize: '12px',
              colors: ["#304758"]
            },
            textAnchor: 'middle',
            distributed: true,
            offsetY: -20,
          },
          grid: {
            show: true,
          },
          colors: ['#9a17ff'],
          tooltip: {
            enabled: true,
            intersect: false,
            style: {  
              fontSize: '12px'
            },
            y: {
              formatter: function (data, opts) {
                return data.toLocaleString('en-US');
              }
            }
          },
          xaxis: {
            type: "category",
            categories: categories,
            labels: {
              style: {
                fontSize: "12px"
              }
            },
          },
          legend: {
            show: true,
            showForSingleSeries: true,
            position: 'top',
            horizontalAlign: 'center',
          }
        };
      }
    }

    this.ngxService.stopBackgroundLoader("loader-defaultMerchant30");
  }

  getTotalMerchant() {
    this.ngxService.startBackgroundLoader("loader-01");
    this.ngxService.startBackgroundLoader("loader-02");
    this.ngxService.startBackgroundLoader("loader-03");
    this.ngxService.startBackgroundLoader("loader-15");

    let nowUTC = moment().utc();
    // Today
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
    // Current month
    let fromDateCM = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonthCM = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    // Last month
    let fromDateLM = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonthLM = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);


    //merchantIds: this.merchantIds ? this.merchantIds : '',
    const payLoad = {qry: 'getTotalMerchant_Merchant', localTZ: this.localTZ, fromDate, endOfMonth, fromDateCM, endOfMonthCM, fromDateLM, endOfMonthLM, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let resData = get(res, 'data', []);
        if(resData){
          resData.forEach((item, index) => {
            this.totalMerchant = item.totalCount;
            this.todayMerchantCount = item.today;
            this.currentMonthMerchant = item.currentMonth;
            this.lastMonthMerchant = item.lastMonth;
          });
        }
        //this.ngxService.stopBackgroundLoader("loader-01");
      },
      (err) => {
      //  this.showAlert(err, "error");
      }
    );

    //merchantIds: this.merchantIds ? this.merchantIds : '',
    const payLoad2 = {qry: 'getTotalMerchant_TPN', localTZ: this.localTZ, fromDate, endOfMonth, fromDateCM, endOfMonthCM, fromDateLM, endOfMonthLM, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected}
    this.DashboardService.getNewDashboardDataInfo(payLoad2).subscribe(
      (res) => {
        let resData = get(res, 'data', []);
        if(!isEmpty(resData)){
          resData.forEach((item, index) => {
            this.totalTPN = item.totalCount;
            this.todayTPNCount = item.today;
            this.currentMonthTPN = item.currentMonth;
            this.lastMonthTPN = item.lastMonth;
          });
        }
        this.ngxService.stopBackgroundLoader("loader-01");
        this.ngxService.stopBackgroundLoader("loader-02");
        this.ngxService.stopBackgroundLoader("loader-03");
        this.ngxService.stopBackgroundLoader("loader-15");
      },
      (err) => {
       // this.showAlert(err, "error in boarding");
      }
    ); 
  }



  async getLast30DaysTransactionVolume() {
    this.ngxService.startBackgroundLoader("loader-defaultTV30");
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(29, 'day').startOf('day').format(this.dateFormat);
    //tpnsList: this.tpns ? this.tpns : '',
    if(this.onMerchantSelected == false) { this.merchantIds = ''; }
    const payLoad = {qry: 'getLast30DaysTransactionVolume', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''}
    const qryData = await this.getNewDashboardDataInfo(payLoad);
   
    const thisClass = this;
    if(qryData) {
      let rawData = qryData;
      let data = [];
      let series = [];
      let categories = [];

      rawData = sortBy(rawData,['perYear','perMonth','perDay']);
      
      rawData.forEach((item, index) => {
        data.push(item.totalVolume);
        const dateMoment = moment({
          year: item.perYear,
          month: item.perMonth - 1,
          day: item.perDay
        });

        const graphDate = dateMoment.format('MMM-DD-YYYY');
        categories.push(graphDate);
      });
      series = [
        {
          name: "Transacion Volume",
          data
        }
      ];
      if (data.length > 0) {
        this.last30TVShow = true;
        this.apexChartTVDefault30 = {
          series: series,
          chart: {
            type: "area",
            height: 350,
            width: '100%',
            stacked: false,
            events: {
              click: function (chart, w, e) {
              }
            },
            toolbar: {
              show: true,
              tools: {
                pan: false,
              } 
            },
            zoom: {
              enabled: true
            }
          },
          title: {
            text: 'Last 30 days',
            align: 'center',
          },
          
          dataLabels: {
            enabled: true,
            enabledOnSeries: undefined,
            formatter: function (val, opts) {
              return thisClass.currency(val.toString());
            },
            textAnchor: 'middle',
            distributed: true,
            style: {
              colors: ['#000000'],
            }
          },
          markers: {
            size: 10,
          },
          grid: {
            show: true,
            padding: {
              left: 30,
            }
          },
          colors: ['#9a17ff'],
          tooltip: {
            enabled: true,
            style: {  
              fontSize: '12px'
            },
            y: {
              formatter: function (data, opts) {
                return '$' + data.toLocaleString('en-US');
              }
            }
          },
          xaxis: {
            type: "category",
            categories: categories,
            labels: {
              style: {
                fontSize: "12px"
              }
            },
          },
          legend: {
            show: false,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100]
            }
          },
        };
      }      
    }

    
    this.ngxService.stopBackgroundLoader("loader-defaultTV30");
  }

  async getLast30DaysTransactionCount() {
    this.ngxService.startBackgroundLoader("loader-defaultTC30");
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(29, 'day').startOf('day').format(this.dateFormat);

    const thisClass = this;
    if(this.onMerchantSelected == false) { this.merchantIds = ''; }
    const payLoad = {qry: 'getLast30DaysTransactionCount', localTZ: this.localTZ, fromDate, endOfMonth, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''}
    const qryData = await this.getNewDashboardDataInfo(payLoad);
  
      if(qryData){
        
        let rawData = qryData;
        let data = [];
        let series = [];
        let categories = [];

        rawData = sortBy(rawData,['perYear','perMonth','perDay']);

        rawData.forEach((item, index) => {
          data.push(item.totalVolume);
          const dateMoment = moment({
            year: item.perYear,
            month: item.perMonth - 1,
            day: item.perDay
          });

          const graphDate = dateMoment.format('MMM-DD-YYYY');
          categories.push(graphDate);
        });
        series = [
          {
            name: "Transaction Count",
            data
          }
        ];
        if (data.length > 0) {
          this.last30TCShow = true;
          this.apexChartTCDefault30 = {
            series: series,
            chart: {
              type: "area",
              height: 350,
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {
                }
              },
              toolbar: {
                show: true,
                tools: {
                  pan: false,
                }                
              },
              zoom: {
                enabled: true
              }
            },
            title: {
              text: 'Last 30 days',
              align: 'center',
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.numbering(val.toString());
              },
              textAnchor: 'middle',
              distributed: true,
              style: {
                colors: ['#000000'],
              }
            },
            markers: {
              size: 10,
              strokeWidth: 15,
            },
            grid: {
              show: true,
              padding: {
                left: 30,
              }
            },
            colors: ['#9a17ff'],
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100]
              }
            },
          };
        }
    //   },
    //   (err) => {
    //     // this.showAlert(err, "error");
    //   }
    // );
      }
    this.ngxService.stopBackgroundLoader("loader-defaultTC30");
  }

  getLast3MonthTransactionsVolume() {
    this.ngxService.startBackgroundLoader("loader-07");
    this.ngxService.startBackgroundLoader("loader-08");
    this.ngxService.startBackgroundLoader("loader-09");
    this.ngxService.startBackgroundLoader("loader-13");
    this.ngxService.startBackgroundLoader("today");

    this.ngxService.startBackgroundLoader("loader-04");
    this.ngxService.startBackgroundLoader("loader-05");
    this.ngxService.startBackgroundLoader("loader-06");
    this.ngxService.startBackgroundLoader("loader-14");

   

    // Last 3 month
    let nowUTCL3M = moment().utc();
    let endOfMonthL3M = nowUTCL3M.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDateL3M = nowUTCL3M.tz(this.localTZ).subtract(3, 'M').startOf('month').format(this.dateFormat);
    // last month
    let nowUTCLM = moment().utc();
    let fromDateLM = nowUTCLM.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonthLM = nowUTCLM.tz(this.localTZ).endOf('month').format(this.dateFormat);
    // current month
    let nowUTCCM = moment().utc();
    let fromDateCM = nowUTCCM.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonthCM = nowUTCCM.tz(this.localTZ).endOf('month').format(this.dateFormat);
    // today 
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);

    
    if(this.onMerchantSelected == false) { this.merchantIds = ''; }
    const payLoad = {qry: 'getLast3MonthTransactionsVolume', localTZ: this.localTZ, fromDate, endOfMonth,fromDateL3M, endOfMonthL3M, fromDateCM, endOfMonthLM, fromDateLM, endOfMonthCM, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected, merchantIds: this.merchantIds ? this.merchantIds : ''}
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let responseData = get(res, 'data', []);
        if(!isEmpty(responseData)){
          responseData.forEach((item, index) => {
            this.last3MonthTransactionsVolume = this.currency(item.last3Month);
            this.lastMonthTransactionsVolume = this.currency(item.lastMonth);
            this.currentMonthTransactionsVolume = this.currency(item.currentMonth);
            this.todayTransactionsVolume = this.currency(item.today);
  
            this.last3MonthTransactionsCount = this.numbering(item.last3MonthCount);
            this.todayTransactionsCount = this.numbering(item.todayCount);
            this.currentMonthTransactionsCount = this.numbering(item.currentMonthCount);
            this.lastMonthTransactionsCount = this.numbering(item.lastMonthCount);
          });
        }
        this.ngxService.stopBackgroundLoader("loader-07");
        this.ngxService.stopBackgroundLoader("loader-08");
        this.ngxService.stopBackgroundLoader("loader-09");
        this.ngxService.stopBackgroundLoader("loader-13");
        this.ngxService.stopBackgroundLoader("today");
        this.ngxService.stopBackgroundLoader("loader-04");
        this.ngxService.stopBackgroundLoader("loader-05");
        this.ngxService.stopBackgroundLoader("loader-06");
        this.ngxService.stopBackgroundLoader("loader-14");
      },
      (err) => {
        // this.showAlert(err, "error in Trans volume");
      }
    );
  }

  // Merchant & TPN DeActivated Count
  getTotalMerchantDeactivated() {
    this.ngxService.startBackgroundLoader("loader-10");
    this.ngxService.startBackgroundLoader("loader-11");
    this.ngxService.startBackgroundLoader("loader-12");
    this.ngxService.startBackgroundLoader("loader-16");

    let nowUTC = moment().utc();

    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);

    let fromDateCM = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonthCM = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);

    let fromDateLM = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonthLM = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);

    let qryWhereOwnedByCustomer ='';
    let qryWhereOwnedBy = '';
    if (!isEmpty(this.selectedISO)) {
      qryWhereOwnedByCustomer = " ownedByCustomer IN ("+this.listIsoHierarchyStr+") AND ";
      qryWhereOwnedBy = " ownedBy IN ("+this.listIsoHierarchyStr+") AND ";  

    } 

  
    const payLoad = {qry: 'getTotalMerchantDeactivated', localTZ: this.localTZ, ownedById: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '', fromDate, endOfMonth, fromDateCM, endOfMonthLM, fromDateLM, endOfMonthCM }
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let responseData = get(res, 'data', []);
        if(!isEmpty(responseData)){
          responseData.forEach((item, index) => {
            this.totalMerchantDeactivated = item.totalCount;
            this.todayMerchantDeactivatedCount = item.today;
            this.currentMonthMerchantDeactivated = item.currentMonth;
            this.lastMonthMerchantDeactivated = item.lastMonth;
          });
        }
        // this.ngxService.stopBackgroundLoader("loader-10");
        // this.ngxService.stopBackgroundLoader("loader-11");
        // this.ngxService.stopBackgroundLoader("loader-12");
        // this.ngxService.stopBackgroundLoader("loader-16");
      },
      (err) => {
        // this.showAlert(err, "error in Deactivated");
      }
    );

    

    const queryTPN = `SELECT COUNT(distinct id) as totalCount, 
    COUNT(distinct id) FILTER (WHERE TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}') as today,
    COUNT(distinct id) FILTER (WHERE TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDateCM}' AND '${endOfMonthCM}') as currentMonth,
    COUNT(distinct id) FILTER (WHERE TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDateLM}' AND '${endOfMonthLM}') as lastMonth 
    FROM portal_tpns WHERE ${qryWhereOwnedByCustomer} status = 'DEACTIVATED'`;

    const payLoad2 = {qry: 'getTotalMerchantDeactivated_TPN', localTZ: this.localTZ, ownedById: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '', fromDate, endOfMonth, fromDateCM, endOfMonthLM, fromDateLM, endOfMonthCM }
    this.DashboardService.getNewDashboardDataInfo(payLoad2).subscribe(
      (res) => {
        let responseData = get(res, 'data', []);
        responseData.forEach((item, index) => {
          this.totalTPNDeactivated = item.totalCount;
          this.todayTPNDeactivatedCount = item.today;
          this.currentMonthTPNDeactivated = item.currentMonth;
          this.lastMonthTPNDeactivated = item.lastMonth;
        });
        this.ngxService.stopBackgroundLoader("loader-10");
        this.ngxService.stopBackgroundLoader("loader-11");
        this.ngxService.stopBackgroundLoader("loader-12");
        this.ngxService.stopBackgroundLoader("loader-16");
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Customers boarding count queries...

  getTotalCustomers() {
    this.isSPCustomerModalOpen = true;
    this.ngxService.startBackgroundLoader("loader-CB01");
    this.ngxService.startBackgroundLoader("loader-CB02");
    this.ngxService.startBackgroundLoader("loader-CB03");
    this.ngxService.startBackgroundLoader("loader-CB04");

    let nowUTC = moment().utc();
    // Today
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
    // Current month
    let fromDateCM = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonthCM = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    // Last month
    let fromDateLM = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonthLM = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
        
    const payLoad = {qry: 'getTotalCustomers', localTZ: this.localTZ, fromDate, endOfMonth, fromDateCM, endOfMonthLM, fromDateLM, endOfMonthCM }
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let responseData = get(res, 'data', []);
        if(!isEmpty(responseData)){
          responseData.forEach((item, index) => {
            this.overallCustomersCount = item.totalCount;
            this.todayCustomersCount = item.today;
            this.thisMonthCustomersCount = item.currentMonth;
            this.lastMonthCustomersCount = item.lastMonth;
          });
        }
        this.ngxService.stopBackgroundLoader("loader-CB01");
        this.ngxService.stopBackgroundLoader("loader-CB02");
        this.ngxService.stopBackgroundLoader("loader-CB03");
        this.ngxService.stopBackgroundLoader("loader-CB04");
      },
      (err) => {
      //  this.showAlert(err, "error");
      }
    );

  }

  getLast30DaysCustomersCount() {
    this.ngxService.startBackgroundLoader("loader-CB05");
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(29, 'day').startOf('day').format(this.dateFormat);

    const thisClass = this;
    const payLoad = {qry: 'getLast30DaysCustomersCount', localTZ: this.localTZ, fromDate, endOfMonth };
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData = sortBy(rawData,['perYear','perMonth','perDay']);

        rawData.forEach((item, index) => {
          data.push(item.totalVolume);
          const dateMoment = moment({
            year: item.perYear,
            month: item.perMonth - 1,
            day: item.perDay
          });

          const graphDate = dateMoment.format('MMM-DD-YYYY');
          categories.push(graphDate);
        });
        series = [
          {
            name: "Customers Count",
            data
          }
        ];
        if (data.length > 0) {
          this.last30CBShow = true;
          this.apexChartCBDefault30 = {
            series: series,
            chart: {
              type: "area",
              height: 350,
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {
                }
              },
              toolbar: {
                show: true,
                tools: {
                  pan: false,
                }                
              },
              zoom: {
                enabled: true
              }
            },
            title: {
              text: 'Last 30 days',
              align: 'center',
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (val, opts) {
                return thisClass.numbering(val.toString());
              },
              textAnchor: 'middle',
              distributed: true,
              style: {
                colors: ['#000000'],
              }
            },
            markers: {
              size: 10,
              strokeWidth: 15,
            },
            grid: {
              show: true,
              padding: {
                left: 30,
              }
            },
            colors: ['#9a17ff'],
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100]
              }
            },
          };
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
    this.ngxService.stopBackgroundLoader("loader-CB05");
  }

  showAlert(data, alertType) {
    this.messageService.add({
      severity: alertType,
      summary: data.status,
      detail: data.message,
    });
  }

  getActivityCard() { 
    this.ngxService.startBackgroundLoader("loader-17");
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
    let qryWhereOwnedByCustomer ='';
    let qryWhereOwnedBy = '';
    let customerId = '';
    let selectedISO = '';
    if (!isEmpty(this.selectedISO)) {
      selectedISO = 'true';
      qryWhereOwnedByCustomer = " ownedByCustomer IN ("+this.listIsoHierarchyStr+") AND ";
      qryWhereOwnedBy = " ownedBy IN ("+this.listIsoHierarchyStr+") AND ";     
      customerId = this.listIsoHierarchyStrParam; 
    } 

    //const queryDeletedMerchants = `SELECT id FROM portal_merchants WHERE ${qryWhereOwnedBy} status = 'DEACTIVATED'`;
    const payLoad1 = {
      qry: 'getActivityCard_Deactivated', 
      selectedISO: selectedISO,
      listIsoHierarchyStr: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '',
      listIsoHierarchyStrParam:  this.listIsoHierarchyStrParam,
    };
    this.DashboardService.getNewDashboardDataInfo(payLoad1).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);
        let deletedMerchantId = [];
        rawData.forEach((item,index) => {
          deletedMerchantId.push(item.id);
        });        
        let deletedMerchantIds = deletedMerchantId.map(item => "'" + item + "'").toString();
        let qryDeletedMerchants = (!isEmpty(deletedMerchantIds)) ? ` AND portal_tpns.ownedByMerchant NOT IN (${deletedMerchantIds})` : '';
 
        const payLoad = 
        {
          qry: 'getActivityCard', 
          customActivityDays: this.customActivityDays,
          listIsoHierarchyStr: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '',
          listIsoHierarchyStrParam:  this.listIsoHierarchyStrParam,
          //deletedMerchantIds: deletedMerchantIds,
          selectedISO: selectedISO,
        };
        this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
          (res) => {
            this.rawActivityData = get(res, 'data', []);
           
            this.rawActivityData = concat(this.rawActivityData, rawData);
            let data90days = [];
            let categories90 = [];       
          
            let days90perc = round(((Number(this.rawActivityData[4].TotalTransactingMerchant)/this.rawActivityData[5].TotalTransactingMerchant)*100));
            let days90invrperc = 100 - (days90perc || 0);        
            this.activityCards.transactPercent = round(days90perc);
            this.activityCards.nonTransactPercent = round(100 - days90perc);
            this.activityCards.numberOfTransactDays = 90;
            // let days30perc = round(((Number(this.rawActivityData[0].days30)/this.rawActivityData[1].TotalTransactingMerchant)*100));
            // let days30invrperc = 100 - (days30perc || 0);
            // let days60perc = round(((Number(this.rawActivityData[0].days60)/this.rawActivityData[1].TotalTransactingMerchant)*100));
            // let days60invrperc = 100 - (days60perc || 0);     
            // let daysNperc = round(((Number(this.rawActivityData[0].daysN)/this.rawActivityData[1].TotalTransactingMerchant)*100));
            // let daysNinvrperc = 100 - (daysNperc || 0);   
   
            data90days = [days90perc || 0, days90invrperc || 0];  
            categories90 = ['Transacted', 'Not-Transacted'];     
          
            if (data90days.length > 0) {
              this.activityChartShow = true;
            this.apexChart23Options = {

              series: data90days,
              labels: categories90,
              chart: {
                type: "donut",
                width: '350',
                animations: {
                  enabled: true,
                  speed: 200,
                }
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        formatter: function (val) {
                          return truncate(val,{'length':15, 'separator':'...'});
                        },
                        color: '#474f52',
                        fontSize: '15px',
                      },
                      value: {
                        formatter: function (val) {
                          return val+'%';
                        },
                        color: '#474f52',
                      },
                      total: {
                        showAlways: false,
                        show: true,
                        label: 'Last 90 days',
                        fontSize: '17px',
                        fontWeight: 'bold',
                        color: '#000000',
                        formatter(w) {
                            return '';
                        },
                      }
                    }
                  }
                }
              },
              colors: ['#9a17ff', '#e0b9ff'],
              tooltip: {
                enabled: false,
              },
              dataLabels: {
                enabled: true,
                formatter: function(data, opts) {
                  return opts.w.globals.series[opts.seriesIndex]+'%';
                },
                style: {
                  fontSize: '13px',
                  fontWeight: 200,
                  colors: ['#ffffff', '#000000'],
                }
              },
              legend: {
                position: 'bottom',
                fontSize: '13px',
                formatter: function(series, opts) {
                  return series + " - " + opts.w.globals.series[opts.seriesIndex] + '%';
                },
              },
            };
            }  else { this.activityChartShow = false; }
            this.ngxService.stopBackgroundLoader("loader-17");
          },
          (err) => {
            // this.showAlert(err, "error in activity card");
          }
        );
     }
    );
  }

  getActivityCard_totalMerchant() { 
    this.ngxService.startBackgroundLoader("loader-17");
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
    let qryWhereOwnedByCustomer ='';
    let qryWhereOwnedBy = '';
    let customerId = '';
    let selectedISO = '';

    if (!isEmpty(this.selectedISO)) {
      selectedISO = 'true';
      qryWhereOwnedByCustomer = " ownedByCustomer IN ("+this.listIsoHierarchyStr+") AND ";
      qryWhereOwnedBy = " ownedBy IN ("+this.listIsoHierarchyStr+") AND ";     
      customerId = this.listIsoHierarchyStrParam; 
    } 

    //const queryDeletedMerchants = `SELECT id FROM portal_merchants WHERE ${qryWhereOwnedBy} status = 'DEACTIVATED'`;
    const payLoad = {
      qry: 'getActivityCard_Deactivated', 
      selectedISO: selectedISO,
      listIsoHierarchyStr: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '',
      listIsoHierarchyStrParam:  this.listIsoHierarchyStrParam,
    };
    let rawData = this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(data => {
      return data
    }) as any
    rawData = get(rawData, 'data', []);
    return rawData;
  }

  async openModalWidgetActivity(content, chartShow) {
    this.ngxService.startBackgroundLoader("loader-17");
    if (chartShow == true) {
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);

    let data30days = [];
    let data60days = [];
    let data90days = [];
    let dataNdays = [];
    let series = [];
    let categories30 = [];
    let categories60 = [];
    let categories90 = [];
    let categoriesN = [];

    let customerId = '';
    if (!isEmpty(this.selectedISO)) {
      
      customerId = this.listIsoHierarchyStrParam;
    } 

    // --- on change custom activity days event call  ---- starts ----- //
   
    if (this.activityCardCustomDays == true) {
      this.ngxService.startBackgroundLoader("loader-20");
      this.rawActivityData = await this.getCustomDaysActivity();
      this.ngxService.stopBackgroundLoader("loader-20");
    }
    
   
    // --- on change custom activity days event call  ---- ends ----- //

    let days30perc = round(((this.rawActivityData[2].TotalTransactingMerchant/this.rawActivityData[5].TotalTransactingMerchant)*100));
    let days30invrperc = 100 - (days30perc || 0);
    let days60perc = round(((this.rawActivityData[3].TotalTransactingMerchant/this.rawActivityData[5].TotalTransactingMerchant)*100));
    let days60invrperc = 100 - (days60perc || 0);        
    let days90perc = round(((this.rawActivityData[4].TotalTransactingMerchant/this.rawActivityData[5].TotalTransactingMerchant)*100));
    let days90invrperc = 100 - (days90perc || 0);
    let daysNperc = round(((Number(this.rawActivityData[1].TotalTransactingMerchant)/this.rawActivityData[5].TotalTransactingMerchant)*100));
    let daysNinvrperc = 100 - (daysNperc || 0); 
    

    if (this.rawActivityData.length > 0) {

      dataNdays = [daysNperc || 0, daysNinvrperc || 0];  
      categoriesN = ['Transacted', 'Not-Transacted'];
      if (dataNdays.length > 0) {
      this.apexChart24Options = {
        series: dataNdays,
        labels: categoriesN,
        chart: {
          type: "donut",
          width: '350',
          events: {
            dataPointSelection: (e, chart?, options?) => {
              const url = this.generateRouteURL('merchant-management/list-merchant?isFilter=true&customer='+customerId+'&activityType='+options.w.config.labels[options.dataPointIndex]+'&txDateRange=custom'+this.customActivityDays);
              window.open(decodeURIComponent(url), '_blank');
            },
            legendClick: function(chartContext, seriesIndex, config) {
             
            }
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  formatter: function (val) {
                    return truncate(val,{'length':15, 'separator':'...'});
                  },
                  color: '#474f52',
                  fontSize: '15px',
                },
                value: {
                  formatter: function (val) {
                    return val+'%';
                  },
                  color: '#474f52',
                },
                total: {
                  showAlways: false,
                  show: false,
                  fontWeight: 'bold',
                  color: '#474f52',
                }
              }
            }
          }
        },
        //colors: ['#fec20c', '#eb1b23'],
        colors: ['#9a17ff', '#e0b9ff'],
        // title: {
        //   text: 'Last N days',
        //   align: 'center',
        //   margin: 10,
        // },
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          enabled: true,
          formatter: function(data, opts) {
            return opts.w.globals.series[opts.seriesIndex]+'%';
          },
          style: {
            fontSize: '13px',
            fontWeight: 200,
            colors: ['#ffffff', '#000000'],
          }
        },
        legend: {
          position: 'bottom',
          fontSize: '14px',
          formatter: function(series, opts) {
            return series + " - " + opts.w.globals.series[opts.seriesIndex] + '%';
          },
        },
      };
      }      

      data30days = [days30perc || 0, days30invrperc || 0];  
      categories30 = ['Transacted', 'Not-Transacted'];
      if(data30days.length > 0) {
      this.apexChart20Options = {
        series: data30days,
        labels: categories30,
        chart: {
          type: "donut",
          width: '350',
          events: {
            dataPointSelection: (e, chart?, options?) => {
              const url = this.generateRouteURL('merchant-management/list-merchant?isFilter=true&customer='+customerId+'&activityType='+options.w.config.labels[options.dataPointIndex]+'&txDateRange=Month');
              window.open(decodeURIComponent(url), '_blank');
            },
            legendClick: function(chartContext, seriesIndex, config) {
             
            }
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  formatter: function (val) {
                    return truncate(val,{'length':15, 'separator':'...'});
                  },
                  color: '#474f52',
                  fontSize: '15px',
                },
                value: {
                  formatter: function (val) {
                    return val+'%';
                  },
                  color: '#474f52',
                },
                total: {
                  showAlways: false,
                  show: false,
                  fontWeight: 'bold',
                  color: '#474f52',
                }
              }
            }
          }
        },
        colors: ['#9a17ff', '#e0b9ff'],
        title: {
          text: 'Last 30 days',
          align: 'center',
          margin: 10,
        },
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          enabled: true,
          formatter: function(data, opts) {
            return opts.w.globals.series[opts.seriesIndex]+'%';
          },
          style: {
            fontSize: '13px',
            fontWeight: 200,
            colors: ['#ffffff', '#000000'],  //'#5C5958'
          }
        },
        legend: {
          position: 'bottom',
          fontSize: '14px',
          formatter: function(series, opts) {
            return series + " - " + opts.w.globals.series[opts.seriesIndex] + '%';
          },
        },
      };
      }

      data60days = [days60perc || 0, days60invrperc || 0];  
      categories60 = ['Transacted', 'Not-Transacted'];
      if (data60days.length > 0) {
      this.apexChart21Options = {
        series: data60days,
        labels: categories60,
        chart: {
          type: "donut",
          width: '350',
          events: {
            dataPointSelection: (e, chart?, options?) => {
              const url = this.generateRouteURL('merchant-management/list-merchant?isFilter=true&customer='+customerId+'&activityType='+options.w.config.labels[options.dataPointIndex]+'&txDateRange=last60Days');
              window.open(decodeURIComponent(url), '_blank');
            },
            legendClick: function(chartContext, seriesIndex, config) {
             
            }
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  formatter: function (val) {
                    return truncate(val,{'length':15, 'separator':'...'});
                  },
                  color: '#474f52',
                  fontSize: '15px',
                },
                value: {
                  formatter: function (val) {
                    return val+'%';
                  },
                  color: '#474f52',
                },
                total: {
                  showAlways: false,
                  show: false,
                  fontWeight: 'bold',
                  color: '#474f52',
                }
              }
            }
          }
        },
        //colors: ['#fec20c', '#eb1b23'],
        colors: ['#9a17ff', '#e0b9ff'],
        title: {
          text: 'Last 60 days',
          align: 'center',
          margin: 10,
        },
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          enabled: true,
          formatter: function(data, opts) {
            return opts.w.globals.series[opts.seriesIndex]+'%';
          },
          style: {
            fontSize: '13px',
            fontWeight: 200,
            colors: ['#ffffff', '#000000'],
          }
        },
        legend: {
          position: 'bottom',
          fontSize: '14px',
          formatter: function(series, opts) {
            return series + " - " + opts.w.globals.series[opts.seriesIndex] + '%';
          },
        },
      };
      }

      data90days = [days90perc || 0, days90invrperc || 0];  
      categories90 = ['Transacted', 'Not-Transacted'];
      if (data90days.length > 0) {
      this.apexChart22Options = {
        series: data90days,
        labels: categories90,
        chart: {
          type: "donut",
          width: '350',
          events: {
            dataPointSelection: (e, chart?, options?) => {
              const url = this.generateRouteURL('merchant-management/list-merchant?isFilter=true&customer='+customerId+'&activityType='+options.w.config.labels[options.dataPointIndex]+'&txDateRange=last90Days');
              window.open(decodeURIComponent(url), '_blank');
            },
            legendClick: function(chartContext, seriesIndex, config) {
            }
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  formatter: function (val) {
                    return truncate(val,{'length':15, 'separator':'...'});
                  },
                  color: '#474f52',
                  fontSize: '15px',
                },
                value: {
                  formatter: function (val) {
                    return val+'%';
                  },
                  color: '#474f52', 
                },
                total: {
                  showAlways: false,
                  show: false,
                  fontWeight: 'bold',
                  color: '#474f52',
                }
              }
            }
          }
        },
        //colors: ['#47a648', '#0068a4'],
        colors: ['#9a17ff', '#e0b9ff'],
        title: {
          text: 'Last 90 days',
          align: 'center',
          margin: 10,
        },
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          enabled: true,
          formatter: function(data, opts) {
            return opts.w.globals.series[opts.seriesIndex]+'%';
          },
          style: {
            fontSize: '13px',
            fontWeight: 200,
            colors: ['#ffffff', '#000000'],
          }
        },
        legend: {
          position: 'bottom',
          fontSize: '14px',
          formatter: function(series, opts) {
            return series + " - " + opts.w.globals.series[opts.seriesIndex] + '%';
          },
        },
      };
      }      

      if (content) {
        this.modalService
          .open(content, { centered: true, size: "xl" })
          .result.then((result) => {
            this.modalWidgetActivity01 = "Modal closed" + result;
          })
          .catch((res) => { });
      }
    }
    this.ngxService.stopBackgroundLoader("loader-17");
    this.activityCardCustomDays = false;
   }
  }

  getCustomDaysActivity(){
    return new Promise((resolve,reject)=>{
        let qryWhereOwnedByCustomer ='';
        let qryWhereOwnedBy = '';
        let customerId = '';
        let selectedISO = '';
        if (!isEmpty(this.selectedISO)) {
          selectedISO = 'true';
          qryWhereOwnedByCustomer = " ownedByCustomer IN ("+this.listIsoHierarchyStr+") AND ";
          qryWhereOwnedBy = " ownedBy IN ("+this.listIsoHierarchyStr+") AND ";     
          customerId = this.listIsoHierarchyStrParam; 
        }         
 
        const payLoad = {
          qry: 'getCustomDaysActivity_Deactivated', 
          listIsoHierarchyStr: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '',
          selectedISO: selectedISO
        };
        this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
          (res) => {
            let rawData = get(res, 'data', []);

            const payLoad = {
              qry: 'getCustomDaysActivity', 
              listIsoHierarchyStr: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '',
              customActivityDays: this.customActivityDays,
              selectedISO: selectedISO
            };
            this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
              (res) => {
                let rawCustomActivityData = get(res, 'data', []);
                resolve(concat(rawCustomActivityData, rawData));
              },
              (err) => {
                resolve(this.rawActivityData);
                // this.showAlert(err, "error");
              }
            );
          }
        );
   
    });
  }

  getMCCCard() {
    // Getting MCC wise store/merchant counts break-up along with MCC name
    this.ngxService.startBackgroundLoader("loader-18");
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
    let selectedISO = '';
    if (!isEmpty(this.selectedISO)) {
      selectedISO = 'true';
    } 
   	 
    const payLoad = {
      qry: 'getMCCCard', 
      selectedISO: selectedISO,
      listIsoHierarchyStr: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '',
    };
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        let rawMCCData = get(res, 'data', []);
        let data = [];
        let categories = [];
        let total_mcc_count = 0;

      
        rawMCCData.forEach(obj => {
          if (obj.mccName === null) {
              obj.mccName = "";
          }
        });
        rawMCCData = orderBy(rawMCCData,['mccName'],['asc']);
       
        if (rawMCCData.length > 0) {
          total_mcc_count = rawMCCData[0].store_count;
        }

        for ( let i = 1 ; i < rawMCCData.length ; i++) {
          if(rawMCCData[i].store_count != 0) {
            data.push(round((rawMCCData[i].store_count / total_mcc_count)*100));
            categories.push(rawMCCData[i].mccName);            
          }
        }     

        if (data.length > 0 && rawMCCData.length > 0) {
          this.mccChartShow = true;
        this.apexChartMCCOptions = {
          series: data,
          labels: categories,
          chart: {
            type: "pie",
            width: '350',
            events: {
              dataPointSelection: (e, chart?, options?) => {
                const url = this.generateRouteURL('merchant-management/list-merchant?isFilter=true&customer='+(!isEmpty(this.selectedISO.id)? this.listIsoHierarchyStrParam : '' )+'&mcc='+options.w.config.labels[options.dataPointIndex].substr(0,4));
                window.open(decodeURIComponent(url), '_blank');
              },
              legendClick: function(chartContext, seriesIndex, config) {
                
              }
            },
            animations: {
              enabled: true,
              speed: 200,
            }
          },
          dataLabels: {
            formatter: function (val, opts) {
              return opts.w.globals.series[opts.seriesIndex]+'%';
            },
            style: {
              fontSize: '13px',
            }
          },
          colors:['#9a17ff', '#c273ff', '#82d87b', '#c2e685'],
          tooltip: {
            enabled: true,
            custom: function({series, seriesIndex, dataPointIndex, w}) {
              return '<div class="arrow_box" style="background-color:'+w.globals.colors[seriesIndex]+'">' + '<span>' + w.globals.labels[seriesIndex] + ' - ' + series[seriesIndex]+ '%</span>' + '</div>'
            },
          },
          legend: {
            show: true,
            position: 'bottom',
            fontSize: '13px',
            //horizontalAlign: 'left',
            formatter(legendName, opts?) {
                return legendName.substr(0,4);
            },
          }
        };
        } else { this.mccChartShow = false; }
        this.ngxService.stopBackgroundLoader("loader-18");
      },
      (err) => {
        // this.showAlert(err, "error in mcc card");
      }
    );
  }

  getLongevityCard() {
    this.ngxService.startBackgroundLoader("loader-19");
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
    let qryWhereOwnedBy = '';
    let customerId = '';
    let selectedISO = '';
    if (!isEmpty(this.selectedISO)) {
      selectedISO = 'true';
      qryWhereOwnedBy = " ownedBy IN ("+this.listIsoHierarchyStr+") AND ";     
      customerId = this.listIsoHierarchyStrParam; 
    } 


    const payLoad = 
    {
      qry: 'getLongevityCard',
      selectedISO: selectedISO,
      listIsoHierarchyStr: !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '',
      listIsoHierarchyStrParam: this.listIsoHierarchyStrParam,
    };
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {
        this.rawActivityData = get(res, 'data', []);
        let data90days = [];
        let categories90 = [];       
       
        let days730perc = round(((Number(this.rawActivityData[0].above2year)/this.rawActivityData[0].totalMerchant)*100));
        let days730invrperc = 100 - (days730perc || 0);
        let days365perc = round(((Number(this.rawActivityData[0].above1year)/this.rawActivityData[0].totalMerchant)*100));
        let days365invrperc = 100 - (days365perc || 0); 
        let days90perc = round(((Number(this.rawActivityData[0].above90days)/this.rawActivityData[0].totalMerchant)*100));
        let days90invrperc = 100 - (days90perc || 0);        
        let days30perc = round(((Number(this.rawActivityData[0].above30days)/this.rawActivityData[0].totalMerchant)*100));
        let days30invrperc = 100 - (days30perc || 0);
        let days60perc = round(((Number(this.rawActivityData[0].above60days)/this.rawActivityData[0].totalMerchant)*100));
        let days60invrperc = 100 - (days60perc || 0);  
        let days30belowperc = round(((Number(this.rawActivityData[0].below30days)/this.rawActivityData[0].totalMerchant)*100));
        let days30belowinvrperc = 100 - (days30belowperc || 0);              

        // data90days = [days730perc || 0, days365perc || 0, days90perc || 0, days60perc || 0, days30perc || 0, days30belowperc || 0];  
        // categories90 = ['> 2 Years', '> 1 Year', '> 90 Days', '> 60 Days', '> 30 Days', '<= 30 Days']; 
        data90days = [days730perc || 0, days365perc || 0, days90perc || 0, days30belowperc || 0];  
        categories90 = ['> 2 Years', '> 1 Year', '> 90 Days', '<= 30 Days'];
      
        if (data90days.length > 0) {
        this.longevityChartShow = true;
        this.apexChartLongevityOptions = {
          series: [{ name: 'Merchants', data: data90days }],
          chart: {
            type: "bar",
            width: '460',
            height: 'auto',
       
            animations: {
              enabled: true,
              speed: 200,
            },
            toolbar: {
              show: false,
            }
          },
          plotOptions: {
            bar: {
              //barHeight: '100%',                    
              borderRadius: 10,
              distributed: true,
              horizontal: true,
              dataLabels: {
                position: 'top'
              },
            },
          },
          colors: ['#9a17ff', '#c273ff', '#82d87b', '#c2e685'],
          tooltip: {
            enabled: false,            
            style: {
              fontSize: '14px',
            }
          },
          dataLabels: {
            enabled: true,
            textAnchor: 'start',            
            formatter: function (val, opt) {
              return val + '%'
            },
            offsetX: 20,
            dropShadow: {
              enabled: false
            },
            style: {
              fontSize: '14px',
              colors: ['#000000', '#000000', '#000000', '#000000'],
            }
          },
          grid: {
            show: false,
          },
          xaxis: {
            type: 'category',
            categories: categories90,
            labels: {
              formatter: function(val, opts) {
                return val + '%';
              },
              show: true,
              style: {
                fontSize: '14px',
              }
            }
          },
          yaxis: {
            show: true,
            forceNiceScale: true,
            labels: {
              style: {
                fontSize: '14px',
              }
            }
          },
          fill: {
            //  type: "pattern",
            opacity: 1,
          },
          legend: {
            show: false,
          },
        };
        }  else { this.longevityChartShow = false; }
        this.ngxService.stopBackgroundLoader("loader-19");
      },
      (err) => {
         //this.showAlert(err, "error in longevity card");
      }
    );
  }  

  openModalWidgetLongevity(content) {
    if (content) {
      this.modalService
        .open(content, { centered: true, size: "lg" })
        .result.then((result) => {
          this.modalWidgetLongevity = "Modal closed" + result;
        })
        .catch((res) => { });
    }
  }

  async getNotTransactTPN() {
    this.ngxService.startBackgroundLoader("loader-NTTPN");
    let isoIds = this.isoIdArray.map(item => "'" + item.id + "'").toString();
    
    let customerId = this.auth.getUser.customerId;
    let ownedByCustomerId = "'"+this.auth.getUser.customerId + "'";
    customerId = this.auth.getUser.customerId;
    if (!isEmpty(isoIds)) { ownedByCustomerId = ownedByCustomerId + "," + isoIds }
    if (!isEmpty(this.selectedISO)) {
      ownedByCustomerId = !isEmpty(this.selectedISO) ? this.listIsoHierarchyStr : '';
      customerId = this.listIsoHierarchyStrParam;
    } 

    let NTTPN = [];
    NTTPN.push(ownedByCustomerId);
    NTTPN.push(this.customNTTPNDays);
    let mariaTPNResult = [];
    mariaTPNResult = await this.getNTTPNlist({isoCustomerId: ownedByCustomerId ? ownedByCustomerId : '', customNTTPNdays: this.customNTTPNDays});
    let mariaTPNNumber = mariaTPNResult.map(item => "'" + item.tpn + "'").toString();
    
    if(mariaTPNResult.length > 0) {
      const payLoad = {qry: 'getNotTransactTPN', listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
      this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
        (res) => {
          this.rawActivityData = get(res, 'data', []); 
          this.NTTPNResult = [];
          mariaTPNResult.forEach((item,index) => {
            if(item.lastTxDate == null || this.rawActivityData.some(i => i.tpn.includes(item.tpn))) {
              this.NTTPNResult.push(item);
            }
          });               
          this.notTransactedTPNCount = this.NTTPNResult.length;
        },
        (err) => {
          // this.showAlert(err, "error");
        }
      );
    }
    this.ngxService.stopBackgroundLoader("loader-NTTPN");
  }

  async getNTTPNlist(bodyData: any) {
    try {
      const getNTTPNlist = await this.DashboardService.getNTTPNlist(bodyData).toPromise().then(data => data);
      return getNTTPNlist.data;
    } catch (err) {
      // this.showAlert(err, "error");
      return [];
    }
  }

  openModalWidgetNTTPNSetting(content) {
    if (content) {
      this.modalService
        .open(content, { centered: true, size: "lg" })
        .result.then((result) => {
          this.modalWidgetNTTPN = "Modal closed" + result;
        })
        .catch((res) => { });
    }
  }

  async openModalWidgetNTTPN(loaderId?:string) {   
    this.ngxService.startBackgroundLoader(loaderId);
    this.ngxService.stopBackgroundLoader(loaderId);
    await this.sleeper(1000);
    if (this.notTransactedTPNCount > 0) {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'xl',
      };
      this.ngbModal.dismissAll();
      this.modalRef = this.ngbModal.open(NotTransactTpnlistv2Component , ngbModalOptions);
      this.modalRef.componentInstance.NTTPNResult = this.NTTPNResult;
      this.modalRef.componentInstance.customNTTPNDays = this.customNTTPNDays;
    }
  }

  async getLessSaleMerchants() {
    this.ngxService.startBackgroundLoader("loader-LSM");
    this.lessSaleMerchantCount = 0;
    this.lessSaleMerchantResult = [];
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
    let isoIds = this.isoIdArray.map(item => "'" + item.id + "'").toString();
    let customerId = this.auth.getUser.customerId;
    let ownedByCustomerId = "'"+this.auth.getUser.customerId + "'";
    customerId = this.auth.getUser.customerId;
    if (!isEmpty(isoIds)) { ownedByCustomerId = ownedByCustomerId + "," + isoIds }
    if (!isEmpty(this.selectedISO)) {
      ownedByCustomerId = this.listIsoHierarchyStr;
      customerId = this.listIsoHierarchyStrParam;
    } 

    let qryWhereMerchantId = '';
    let qryDeletedMerchantId = ` AND pcb.merchantId NOT IN (SELECT id FROM portal_merchants WHERE status = 'DEACTIVATED') `;
    if(!isEmpty(this.merchantIds)) {
      qryWhereMerchantId = ` AND pcb.merchantId IN (${this.merchantIds}) `;
      qryDeletedMerchantId = '';
    }

  
      const payLoad = {qry: 'getLessSaleMerchantsv1', customLSMdays: this.customLSMdays, listIsoHierarchyStr: this.listIsoHierarchyStr? this.listIsoHierarchyStr : '', onMerchantSelected: this.onMerchantSelected};
      this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
        async (res) => {
          this.rawActivityData =  get(res, 'data', []);         
          this.lessSaleMerchantCount = this.rawActivityData.length;
          this.lessSaleMerchantResult = this.rawActivityData;
          let newMerchantIds = this.rawActivityData.map(item => "'" + item.merchantId + "'").toString();
          let merchantInfo = await this.getMerchantInfo(newMerchantIds);

          merchantInfo = orderBy(merchantInfo,['merchantId'],['asc']);
          this.lessSaleMerchantResult = orderBy(this.lessSaleMerchantResult,['merchantId'],['asc']);

          for(let i=0; i < merchantInfo.length; i++) {
            if (this.lessSaleMerchantResult[i].merchantId == merchantInfo[i].merchantId) {
              this.lessSaleMerchantResult[i].merchantdba = merchantInfo[i].merchantdba;
              this.lessSaleMerchantResult[i].email = merchantInfo[i].email;
              this.lessSaleMerchantResult[i].phoneNumber = merchantInfo[i].phoneNumber;
              this.lessSaleMerchantResult[i].AVG7Days = (this.lessSaleMerchantResult[i].AVG7Days/100);
              this.lessSaleMerchantResult[i].AVG3Month = (this.lessSaleMerchantResult[i].AVG3Month/100);
              this.lessSaleMerchantResult[i].Diff = parseFloat((100 - ((this.lessSaleMerchantResult[i].AVG7Days / this.lessSaleMerchantResult[i].AVG3Month)*100)).toFixed(2));
            }
          }
          this.lessSaleMerchantResult = orderBy(this.lessSaleMerchantResult,['Diff'],['desc']);
          
        },
        (err) => {
          // this.showAlert(err, "error");
        }
      );
      this.ngxService.stopBackgroundLoader("loader-LSM");
  }

  async getMerchantInfo(bodyData: string[]) {
    try {
      const getMerchantInfo = await this.DashboardService.getMerchantInfo(bodyData).toPromise().then(data => data);
      return getMerchantInfo.data;
    } catch (err) {
      // this.showAlert(err, "error");
      return [];
    }
  }

  async openModalWidgetLSM(loaderId?:string) {   
    this.ngxService.startBackgroundLoader(loaderId);
    this.ngxService.stopBackgroundLoader(loaderId);
    await this.sleeper(1000);
    if (this.lessSaleMerchantCount > 0) {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'xl',
      };
      this.ngbModal.dismissAll();
      this.modalRef = this.ngbModal.open(LessSalesMerchantsv2Component , ngbModalOptions);
      this.modalRef.componentInstance.LSMResult = this.lessSaleMerchantResult;
      this.modalRef.componentInstance.customLSMdays = this.customLSMdays;
    }
  }

  openModalWidgetLSMSetting(content) {
    if (content) {
      this.modalService
        .open(content, { centered: true, size: "lg" })
        .result.then((result) => {
          this.modalWidgetLSM = "Modal closed" + result;
        })
        .catch((res) => { });
    }
  }
  
  navigateToMerchant(navigateParams, numberOfMerchants){
    let customerQuery = {};
    if(!isEmpty(this.selectedISO)){
      //navigateParams["customer"] = this.selectedISO.id;
      navigateParams["customer"] = this.listIsoHierarchyStrParam;
    }
    if(numberOfMerchants > 0) {
      this.router.navigate(['/merchant-management/list-merchant'], { queryParams: navigateParams});
    }
  }

  navigateToTransaction(navigateParams, numberOfMerchants) {
    let customerQuery = {};
    if(!isEmpty(this.selectedISO)){
      navigateParams["customer"] = this.selectedISO.id;
    } else {
      navigateParams["customer"] = '';
    }
    if(!isEmpty(this.selectedMerchant)){
      navigateParams["dba"] = this.selectedMerchant.id;
      navigateParams["queryString"] = this.selectedMerchant.dba;
    } else {
      navigateParams["dba"] = '';
    }    
    numberOfMerchants = numberOfMerchants.replace(/[^\d.-]/g, '');    
    if(numberOfMerchants > 0) {
      const url = this.generateRouteURL('transaction-management/transactions?date='+navigateParams["date"]+'&customer='+navigateParams["customer"]+'&dba='+navigateParams["dba"]);
      window.open(decodeURIComponent(url), '_blank');
    }
  }

  naviagteMerchantList(numberOfMerchants) {
    let customerQuery = {};
    if(!isEmpty(this.selectedISO)){
      //customerQuery = {customer: this.selectedISO.id};
      customerQuery = {customer: this.listIsoHierarchyStrParam};
    }
    if(numberOfMerchants > 0) {
      this.router.navigate(['/merchant-management/list-merchant'], { queryParams: customerQuery});
    }
  }

  getDeactivatedMerchantList(params, numberOfMerchants,loaderId?:string) {
    this.ngxService.startBackgroundLoader(loaderId)
    this.isLoading=true;
    let deactivatedMerchant;
    let customerQuery= {};
    if(!isEmpty(this.selectedISO)){
      customerQuery = {customer: this.selectedISO.id};
    }
    if(numberOfMerchants > 0) {
      this.commonService.getCommonHttpClientQueryParams(apiLinks.deactivatedMerchants,{isFilter: true,dateRange: params, ...customerQuery}).subscribe(
        (res) => {
          deactivatedMerchant = res.data;
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'xl',
      };
      this.ngbModal.dismissAll();
      this.modalRef = this.ngbModal.open(DeactivatedMerchantListv2Component, ngbModalOptions);
      this.modalRef.componentInstance.deactivatedMerchant = deactivatedMerchant;
      this.isLoading=false;
    },
    (err) => {
    console.log(err);
    });
    }
    this.ngxService.stopBackgroundLoader(loaderId)
  }

  generateRouteURL(urlString) {  
    return this.router.serializeUrl(
      this.router.createUrlTree([urlString])
    );
  }

  getSPQuery(customerids, salesPersonName, lastcard = '') {
    this.isSecondModalOpen = false;

    //today 
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfDate = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
    // current month
    let nowUTCCM = moment().utc();
    let fromDateCM = nowUTCCM.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonthCM = nowUTCCM.tz(this.localTZ).endOf('month').format(this.dateFormat);
    // last month
    let nowUTCLM = moment().utc();
    let fromDateLM = nowUTCLM.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonthLM = nowUTCLM.tz(this.localTZ).endOf('month').format(this.dateFormat);

    const payLoad = {qry: lastcard ? 'getSPQuery1' : 'getSPQuery2', customerIds: customerids ? customerids : '', fromDate, endOfDate, fromDateCM, endOfMonthLM, fromDateLM, endOfMonthCM };
    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {     
        let customerWiseTpnCount =  get(res, 'data', []);
        let ngbModalOptions: NgbModalOptions = {
          backdrop: 'static',
          keyboard: false,
          centered: true,
          size: 'xl',
        };
        this.modalRef = this.ngbModal.open(CustomersTpnListv2Component, ngbModalOptions);
        this.modalRef.componentInstance.customerWiseTpnCount = customerWiseTpnCount;
        this.modalRef.componentInstance.salesPersonName = salesPersonName;      
        this.isSecondModalOpen = true;  
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
    
  }

  getSPCustomerQuery(dtRange = '',loaderId,customersCount) {
    this.isLoading=true;
    this.isSPCustomerModalOpen = false;
    let nowUTC = moment().utc();
    let endOfMonth = '';
    let fromDate = '';
    let query = '';
    let payLoad : any;   
    if(customersCount > 0) {

      if(dtRange == 'today') {

        endOfMonth = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
        fromDate = nowUTC.tz(this.localTZ).startOf('day').format(this.dateFormat);
       
        payLoad = {qry: 'getSPCustomerQuery_dtrng', localTZ: this.localTZ, fromDate, endOfMonth};

      } else if(dtRange == 'thismonth') {
  
        let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
        let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
        
        payLoad = {qry: 'getSPCustomerQuery_dtrng', localTZ: this.localTZ, fromDate, endOfMonth};
  
      } else if(dtRange == 'lastmonth') {
        
        let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
        let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
        payLoad = {qry: 'getSPCustomerQuery_dtrng', localTZ: this.localTZ, fromDate, endOfMonth};
  
      } else {
  
        payLoad = {qry: 'getSPCustomerQuery_overall', localTZ: this.localTZ};
  
      }
      this.ngxService.startBackgroundLoader(loaderId);
      this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
        (res) => {
          this.SPCustShowDiv = true;
          let rawData = get(res, 'data', []);
          rawData = rawData.sort((a, b) => b.tpn - a.tpn);
          let customerWiseTpnCount = rawData;
          this.SPWiseCustomers = customerWiseTpnCount;
  
          customerWiseTpnCount.forEach(obj => {
            if (obj.state in this.USstate) {
              obj.state = this.USstate[obj.state];
            }
          });
          let ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            centered: true,
            size: 'xl',
          };
          this.modalRef = this.ngbModal.open(CustomersTpnListv2Component, ngbModalOptions);
          this.modalRef.componentInstance.customerWiseTpnCount = customerWiseTpnCount;
          this.modalRef.componentInstance.timePeriod = dtRange;
          this.modalRef.componentInstance.SPCustShowDiv = true;
          this.isSPCustomerModalOpen = true;  
          this.isLoading=false;
        },
        (err) => {          
          //   this.showAlert(err, "error");
          
        }
      ); 
      this.ngxService.stopBackgroundLoader(loaderId);
    }
    else{
      this.isLoading = false;
    }  
  }

  openWidgetSPCustomer2(loaderId?:string, dtRange = '',) {
    this.getSPCustomerQuery(dtRange,loaderId,1);
  }
  openModalWidgetSPCustomer7(content,dtRange='',customersCount,loaderId?:string){
    this.isChartShow=false;
    this.isStateShow=true;
    this.configUSChart=[];
    this.openModalWidgetSPCustomer(null,dtRange, customersCount,loaderId);
  
  }
  openModalWidgetSPCustomertoday(content, customersCount,loaderId?:string){
     let dtRange = "today";
     this.isStateShow = true;
     this.isShowLabel = false;
     this.isChartShow = false;
     this.configUSChart = [];
     this.openModalWidgetSPCustomer(content,dtRange, customersCount,loaderId);
  }

  openModalWidgetSPCustomer(content, dtRange='', customersCount,loaderId) {

    let nowUTC = moment().utc();
    let endOfMonth = '';
    let fromDate = '';
    let query = '';
    let payLoad : any;
    
    this.modalTitle='View by Geo-location [ US state wise Customers (ISO/Agents) distribution ]';
    this.isLoading = true;
    if(customersCount == 0){
       this.isShowLabel = true;
     }
    if (content && customersCount > 0) {     
      this.modalService
        .open(content, { centered: true, size: "xl", keyboard: false, backdrop: 'static' })
        .result.then((result) => {
          this.isShowLabel = true;
          this.modalWidgetSPCustomer2 = "Modal closed" + result;
        })
        .catch((res) => { });
    }  

    let electionResults: any = [
      {
        name: 'AL',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'AK',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'AZ',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'AR',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'CA',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'CO',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'CT',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'DE',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'FL',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'GA',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'HI',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'ID',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'IL',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'IN',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'IA',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'KS',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'KY',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'LA',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'ME',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'MD',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'MA',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'MI',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'MN',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'MS',
        winningVotes: 0,
        totalVotes: 0,
      },
      {},
      {
        name: 'MO',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'MT',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'NE',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'NV',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'NH',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'NJ',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'NM',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'NY',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'NC',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'ND',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'OH',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'OK',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'OR',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'PA',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'RI',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'SC',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'SD',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'TN',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'TX',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'UT',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'VT',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'VA',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'WA',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'WV',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'WI',
        winningVotes: 0,
        totalVotes: 0,
      },
      {
        name: 'WY',
        winningVotes: 0,
        totalVotes: 0,
      },
    ];
    
    let stateNames: any = {
      AL: 'Alabama',
      AK: 'Alaska',
      AS: 'American Samoa',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DE: 'Delaware',
      DC: 'District Of Columbia',
      FM: 'Federated States Of Micronesia',
      FL: 'Florida',
      GA: 'Georgia',
      GU: 'Guam',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      ME: 'Maine',
      MH: 'Marshall Islands',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MS: 'Mississippi',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      MP: 'Northern Mariana Islands',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PW: 'Palau',
      PA: 'Pennsylvania',
      PR: 'Puerto Rico',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VI: 'Virgin Islands',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming',
    };
    
    // let colorGradient = [
    //   '#feebe2',
    //   '#fcc5c0',
    //   '#fa9fb5',
    //   '#f768a1',
    //   '#dd3497',
    //   '#ae017e',
    //   '#7a0177',
    // ];

    let colorGradient = [
      // '#C0C0C0',
      // '#fcc5c0',
      // '#fa9fb5',
      // '#f768a1',
      // '#dd3497',
      // '#ae017e',
      // '#7a0177',
      // '#7a0477',
      // '#7a0777',
      // '#7a0377',
      // '#EAFAF1',
      // '#D5F5E3',
      // '#ABEBC6',
      // '#82E0AA',
      // '#58D68D',

      // Green - light to dark
      // '#2ECC71',
      // '#28B463',
      // '#239B56',
      // '#1D8348',
      // '#186A3B',
      // '#145A32',
      // '#27AE60',
      // '#229954',
      // '#1E8449',
      // '#196F3D',
      // '#145A32'

      '#ccffcc',  //Green
      '#99ff99',  //Green
      '#33ff33',  //Green
      '#00cc00',  //Green
      '#006600',  //Green
      '#ffcc80',
      '#ffad33',
      '#ff9900',
      '#cc7a00',
      '#995c00',
      '#995c00'
    ];   

    if(dtRange == 'today') {
      this.period = 'today';
      endOfMonth = nowUTC.tz(this.localTZ).endOf('day').format(this.dateFormat);
      fromDate = nowUTC.tz(this.localTZ).startOf('day').format(this.dateFormat);
      query = `SELECT state, count(*) AS totalCount FROM portal_customers WHERE TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' group by state `;
      payLoad = {qry: 'openModalWidgetSPCustomer_dtrng', localTZ: this.localTZ, fromDate, endOfMonth};

    } else if(dtRange == 'thismonth') {

      let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
      let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
      query = `SELECT state, count(*) AS totalCount FROM portal_customers WHERE TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' group by state `;
      payLoad = {qry: 'openModalWidgetSPCustomer_dtrng', localTZ: this.localTZ, fromDate, endOfMonth};

    } else if(dtRange == 'lastmonth') {
      
      let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
      let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
      query = `SELECT state, count(*) AS totalCount FROM portal_customers WHERE TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', '${this.localTZ}') BETWEEN '${fromDate}' AND '${endOfMonth}' group by state `;
      payLoad = {qry: 'openModalWidgetSPCustomer_dtrng', localTZ: this.localTZ, fromDate, endOfMonth};

    } else {

      query = `SELECT state, count(*) AS totalCount FROM portal_customers group by state `;
      payLoad = {qry: 'openModalWidgetSPCustomer_overall', localTZ: this.localTZ};

    }

    this.SPCustomerdtRange = dtRange;
    const thisClass = this;

    this.DashboardService.getNewDashboardDataInfo(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let usRawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];
        

        for(const usData of get(res, 'data', [])) {
         
            const data = electionResults.filter(pilot => pilot.name == usData.state);
            
            if (data) {
              let index = electionResults.indexOf(data[0]);
              if(electionResults[index]) {
                electionResults[index].winningVotes = usData.totalCount;
                electionResults[index].totalVotes = customersCount;
                electionResults[index].percent = Math.floor(((usData.totalCount/customersCount)*100)/10);
              }
            }
        }
      
        this.configUSChart = this.setResults(electionResults, stateNames, colorGradient);
        this.isLoading = false;
       // this.ngxService.stopBackgroundLoader(loaderId);

      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }


  // ******* US Geo-location Map - Distributions - Source codes ---- Starts **********
  getLatLongArray(zipCodeArr) {
    const sampleObject = {};
    for (const item of zipCodeArr) {
      const zipCodeData = zipcodes.lookup(item.zipCode);
      if(zipCodeData) {
        sampleObject[zipCodeData.city] = {  //+'-'+zipCodeData.zip
          iPopulation: parseInt(item.totalCount, 10),
          sPopulation: item.totalCount,
          latitude: zipCodeData.latitude,
          longitude: zipCodeData.longitude,
          name: zipCodeData.city+'-'+zipCodeData.zip,
          //name: zipCodeData.city,
          state: zipCodeData.state,
          zip: zipCodeData.zip,
          x: '0px',
          y: '0px'
        };
      }
    }
  
    return sampleObject;
  }

  getUSStateArray(usStateArr) {
    const sampleObject = {};
    for (const item of usStateArr) {
      if(item) {
        sampleObject[item.state] = {  //+'-'+zipCodeData.zip
          backgroundColor: '#E6EE9C #DCE775', // '#D0FAAE ',
          tooltip: {
            text: this.USstate[item.state] + ' (' + item.totalCount + ')',
            fontSize: '18px',
            textAlign: 'left',
            width: '200px',
            wrapText: true,
          },
        };
      }
    }
  
    return sampleObject;
  }

  callBrazilChart(oStates) {
    
    let defaultColor = '#FFFFFF';   //'#C0C0C0';

    return {
        gui: {
          watermark: {
            position: 'tr',
          },
        },
        title: {
          text: 'Merchant\'s acquisition geo-location heatmap',
          textAlign: 'left',
          fontSize: '14px'
        },
        shapes: [
          {
            type: 'zingchart.maps',
            options: {
              name: 'usa',
              offsetX: '-10px',
              offsetY: '35px',
              scale: true,
              style: {
                backgroundColor: '#FFFFFF',
                borderColor: '#000000',
                controls: {
                  placement: 'br'
                },
                hoverState: {
                  visible: false
                },
                label: {
                  fontSize: '12px',
                  visible: true,
                 },
                tooltip: {
                  backgroundColor: '#ff9800',
                  borderWidth: '0px',
                  fontColor: '#FFF',
                  fontSize: '18px'
                },
                items: oStates,
              },
            }
          }
        ],
      };
  } 

  // US Geo Map - HELPER METHODS -----------------------------
  drawCity(city, oCities) {
    let defaultColor = '#0000FF';//'#800000';
    return {
      type: 'circle', //type: 'star9',
      id: city,
      tooltip: {
        text: this.buildTooltipText(city, oCities),
        padding: '10px',
        backgroundColor: '#FFF',
        borderColor: (oCities[city].color) ? oCities[city].color : this.calculateCircleSize(oCities[city].iPopulation).rangeColor,
        borderRadius: '5px',
        borderWidth: '2px',
        fontSize: '14px',
        textAlign: 'left'
      },
      alpha: .6,
      backgroundColor: (oCities[city].color) ? oCities[city].color : this.calculateCircleSize(oCities[city].iPopulation).rangeColor,
      borderWidth: '3px',
      borderColor: 'none',
      hoverState: {
        alpha: .1,
        borderAlpha: 1,
        borderColor: (oCities[city].color) ? oCities[city].color : this.calculateCircleSize(oCities[city].iPopulation).rangeColor,
        size: this.calculateCircleSize(oCities[city].iPopulation).range + 2
      },
      map: 'usa',
      size: this.calculateCircleSize(oCities[city].iPopulation).range,
      x: oCities[city].x,
      y: oCities[city].y,
    }
  }
  
  /** * Code below calculates bubble size */
  buildTooltipText(city, oCities) {
    return '<b>Merchants acquisition</b><br>' + oCities[city].name + ' ('+oCities[city].state+') : ' + oCities[city].sPopulation;
  }
  
  calculateCircleSize(population) {
    let range = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65];    
    let rangeColor = ['#0000FF', '#00F7FF', '#FF2600', '#1AFF00', '#FF7700', '#00C3FF', '#FFF700', '#FB00FF', '#FF007B', '#0A041C', '#6A138F', '#7A2E02', '#AB0A1A'];
    let domain = this.generateDomain('quantize', [1, 500], range);
    let keyValue = this.quantize(population, domain, range, rangeColor);
    return keyValue;      //return keyValue.range;
  }

  leftOrRight(value, left, right) {
    let leftDiff = Math.abs(value - left);
    let rightDiff = Math.abs(value - right);
    return leftDiff < rightDiff ? true : false;
  }
  
  isBetween(value, left, right) {
    return value > left && value < right;
  }
  
  quantizeIndex(value, scale) {
    let first = scale[0];
    let last = scale[scale.length - 1];
    for (let i = 0; i < scale.length; i++) {
      if (value <= first) {
        return 0;
      }
      else if (value >= last) {
        return scale.length - 1;
      }
      else if (i < scale.length - 1) {
        if (value == scale[i]) {
          return i;
        }
        else {
          let current = scale[i];
          let next = scale[i + 1];
          if (this.isBetween(value, current, next)) {
            return this.leftOrRight(value, current, next) ? i : i + 1;
          }
        }
      }
    }
  }
  
  // define mix max for domain
  quantize(value, domain, range, rangeColor) {
    let index = this.quantizeIndex(value, domain);
    return {
      range: range[index],
      rangeColor: rangeColor[index],
      domain: domain[index]
    }
  }
  
  quantizeDomain(aDomain, aRange) {
    let iMin = aDomain[0];
    let iMax = aDomain[1];
    let iSlope = (iMax - iMin) / (aRange.length - 1);
    let aScale = [];
    for (let i = 0; i < aRange.length; i++) {
      aScale[i] = (iSlope * i + iMin);
    }
    return aScale;
  }
  
  generateDomain(sType, aDomain, aRange) {
    let aScale = aDomain;
    if (sType == 'quantize') {
      aScale = this.quantizeDomain(aDomain, aRange)
    }
    return aScale;
  }  

  groupCityArray(rawData) {
    const groupedData = rawData.reduce((result, item) => {
      const { city, totalCount } = item;            
      if (!result[city]) {
        result[city] = { city, totalCount: 0, zipCode: item.zipCode };
      }            
      result[city].totalCount += totalCount;            
      return result;
    }, {});
    
    const groupedArray = Object.values(groupedData);
    return groupedArray;
  }

  groupStateArray(rawData) {
    const groupedData = rawData.reduce((result, item) => {
      const { state, totalCount } = item;            
      if (!result[state]) {
        result[state] = { state, totalCount: 0 };
      }            
      result[state].totalCount += totalCount;            
      return result;
    }, {});
    
    const groupedArray = Object.values(groupedData);
    return groupedArray;
  }
  // ******* US Geo-location Map - Distributions - Source codes ---- Ends **********


  async getDashboardDataInfo(payLoad) {
   
    try {
      const data = await this.DashboardService.getDashboardDataInfo(payLoad).toPromise();
  
      return data.data;
    } catch (err) {
     
      console.error(err);
      return [];
    }
  }

  async getNewDashboardDataInfo(payLoad) {
  
    try {
      const data = await this.DashboardService.getNewDashboardDataInfo(payLoad).toPromise();
      return data.data;
    } catch (err) {
      console.error(err);
      return [];
    }
  }

  getFilteredChartArray(arrayToFilter = [], argSplit) {
    const currentMonth = moment().month() + 1; // Adding 1 because months are zero-indexed
    const currentYear = moment().year();
    if (argSplit == 1) {
    // Filter the array to keep only the past or current month-year values
    const filteredArray = arrayToFilter.filter(item => {
      const parts = item.split(' - ');
      const itemMonth = moment().month(parts[0]).month() + 1; // Adding 1 because months are zero-indexed
      const itemYear = parseInt(parts[1]) + 2000;
      
      // Keep the item if it's from a past or current month-year
      return itemYear < currentYear || (itemYear === currentYear && itemMonth <= currentMonth);      
    });      
    return filteredArray;  
    } else {
    // Filter the array to keep only the past or current month-year values
      const filteredArray = arrayToFilter.filter(item => {
      // Keep the item if it's from a past or current month-year
      return item.perYear < currentYear || (item.perYear === currentYear && item.perMonth <= currentMonth);
    });        
    return filteredArray;
    }
  }

}
